const express = [
  {
    "label": "圆通速递",
    "value": "yuantong"
  },
  {
    "label": "韵达快递",
    "value": "yunda"
  },
  {
    "label": "中通快递",
    "value": "zhongtong"
  },
  {
    "label": "邮政快递包裹",
    "value": "youzhengguonei"
  },
  {
    "label": "申通快递",
    "value": "shentong"
  },
  {
    "label": "顺丰速运",
    "value": "shunfeng"
  },
  {
    "label": "EMS",
    "value": "ems"
  },
  {
    "label": "极兔速递",
    "value": "jtexpress"
  },
  {
    "label": "京东物流",
    "value": "jd"
  },
  {
    "label": "百世快递",
    "value": "huitongkuaidi"
  },
  {
    "label": "邮政标准快递",
    "value": "youzhengbk"
  },
  {
    "label": "丰网速运",
    "value": "fengwang"
  },
  {
    "label": "德邦",
    "value": "debangwuliu"
  },
  {
    "label": "德邦快递",
    "value": "debangkuaidi"
  },
  {
    "label": "中通国际",
    "value": "zhongtongguoji"
  },
  {
    "label": "速必达",
    "value": "subida"
  },
  {
    "label": "韵达快运",
    "value": "yundakuaiyun"
  },
  {
    "label": "优速快递",
    "value": "youshuwuliu"
  },
  {
    "label": "国际包裹",
    "value": "youzhengguoji"
  },
  {
    "label": "中通快运",
    "value": "zhongtongkuaiyun"
  },
  {
    "label": "联昊通",
    "value": "lianhaowuliu"
  },
  {
    "label": "宅急送",
    "value": "zhaijisong"
  },
  {
    "label": "DHL-中国件",
    "value": "dhl"
  },
  {
    "label": "百世快运",
    "value": "baishiwuliu"
  },
  {
    "label": "UPS",
    "value": "ups"
  },
  {
    "label": "跨越速运",
    "value": "kuayue"
  },
  {
    "label": "特急送",
    "value": "lntjs"
  },
  {
    "label": "安能快运",
    "value": "annengwuliu"
  },
  {
    "label": "加运美",
    "value": "jiayunmeiwuliu"
  },
  {
    "label": "安得物流",
    "value": "annto"
  },
  {
    "label": "FedEx-国际件",
    "value": "fedex"
  },
  {
    "label": "UPS-全球件",
    "value": "upsen"
  },
  {
    "label": "速尔快递",
    "value": "suer"
  },
  {
    "label": "EWE全球快递",
    "value": "ewe"
  },
  {
    "label": "USPS",
    "value": "usps"
  },
  {
    "label": "壹米滴答",
    "value": "yimidida"
  },
  {
    "label": "D速快递",
    "value": "dsukuaidi"
  },
  {
    "label": "日日顺物流",
    "value": "rrs"
  },
  {
    "label": "顺心捷达",
    "value": "sxjdfreight"
  },
  {
    "label": "YunExpress",
    "value": "yuntrack"
  },
  {
    "label": "京广速递",
    "value": "jinguangsudikuaijian"
  },
  {
    "label": "顺丰快运",
    "value": "shunfengkuaiyun"
  },
  {
    "label": "DHL-全球件",
    "value": "dhlen"
  },
  {
    "label": "联邦快递",
    "value": "lianbangkuaidi"
  },
  {
    "label": "京东快运",
    "value": "jingdongkuaiyun"
  },
  {
    "label": "信丰物流",
    "value": "xinfengwuliu"
  },
  {
    "label": "丹鸟",
    "value": "danniao"
  },
  {
    "label": "Titan泰坦国际速递",
    "value": "timelytitan"
  },
  {
    "label": "递四方",
    "value": "disifang"
  },
  {
    "label": "TNT",
    "value": "tnt"
  },
  {
    "label": "中远e环球",
    "value": "cosco"
  },
  {
    "label": "海信物流",
    "value": "savor"
  },
  {
    "label": "同城快寄",
    "value": "shpost"
  },
  {
    "label": "汇森速运",
    "value": "huisenky"
  },
  {
    "label": "威时沛运货运",
    "value": "wtdchina"
  },
  {
    "label": "速腾快递",
    "value": "suteng"
  },
  {
    "label": "GLS",
    "value": "gls"
  },
  {
    "label": "宏递快运",
    "value": "hd"
  },
  {
    "label": "燕文物流",
    "value": "yw56"
  },
  {
    "label": "美快国际物流",
    "value": "meiquick"
  },
  {
    "label": "卓志速运",
    "value": "chinaicip"
  },
  {
    "label": "宇鑫物流",
    "value": "yuxinwuliu"
  },
  {
    "label": "Fedex-国际件-中文",
    "value": "fedexcn"
  },
  {
    "label": "EMS-国际件",
    "value": "emsguoji"
  },
  {
    "label": "日本（Japan Post）",
    "value": "japanposten"
  },
  {
    "label": "UBI Australia",
    "value": "gotoubi"
  },
  {
    "label": "申通国际",
    "value": "stosolution"
  },
  {
    "label": "天天快递",
    "value": "tiantian"
  },
  {
    "label": "顺昌国际",
    "value": "shunchangguoji"
  },
  {
    "label": "DPD",
    "value": "dpd"
  },
  {
    "label": "威盛快递",
    "value": "wherexpess"
  },
  {
    "label": "货拉拉物流",
    "value": "huolalawuliu"
  },
  {
    "label": "韩国邮政",
    "value": "koreapostcn"
  },
  {
    "label": "邦泰快运",
    "value": "btexpress"
  },
  {
    "label": "鑫正一快递",
    "value": "zhengyikuaidi"
  },
  {
    "label": "澳邮中国快运",
    "value": "auexpress"
  },
  {
    "label": "时安达速递",
    "value": "goex"
  },
  {
    "label": "众邮快递",
    "value": "zhongyouex"
  },
  {
    "label": "易客满",
    "value": "ecmscn"
  },
  {
    "label": "新顺丰（NSF）",
    "value": "nsf"
  },
  {
    "label": "Xlobo贝海国际",
    "value": "xlobo"
  },
  {
    "label": "SYNSHIP快递",
    "value": "synship"
  },
  {
    "label": "富吉速运",
    "value": "fujisuyun"
  },
  {
    "label": "天地华宇",
    "value": "tiandihuayu"
  },
  {
    "label": "叁虎物流",
    "value": "sanhuwuliu"
  },
  {
    "label": "TNT-全球件",
    "value": "tnten"
  },
  {
    "label": "方舟速递",
    "value": "arkexpress"
  },
  {
    "label": "转运四方",
    "value": "zhuanyunsifang"
  },
  {
    "label": "拉火速运",
    "value": "lahuoex"
  },
  {
    "label": "海外环球",
    "value": "haiwaihuanqiu"
  },
  {
    "label": "九曳供应链",
    "value": "jiuyescm"
  },
  {
    "label": "CJ物流",
    "value": "doortodoor"
  },
  {
    "label": "德坤物流",
    "value": "dekuncn"
  },
  {
    "label": "行云物流",
    "value": "xyb2b"
  },
  {
    "label": "三态速递",
    "value": "santaisudi"
  },
  {
    "label": "澳洲飞跃物流",
    "value": "rlgaus"
  },
  {
    "label": "AAE-中国件",
    "value": "aae"
  },
  {
    "label": "出口易",
    "value": "chukou1"
  },
  {
    "label": "安能快递",
    "value": "ane66"
  },
  {
    "label": "盛辉物流",
    "value": "shenghuiwuliu"
  },
  {
    "label": "景光物流",
    "value": "jgwl"
  },
  {
    "label": "荷兰邮政(PostNL international registered mail)",
    "value": "postnl"
  },
  {
    "label": "中铁快运",
    "value": "ztky"
  },
  {
    "label": "DPD Germany",
    "value": "dpdgermany"
  },
  {
    "label": "四季安物流",
    "value": "sja56"
  },
  {
    "label": "圆通国际",
    "value": "yuantongguoji"
  },
  {
    "label": "盛丰物流",
    "value": "sfwl"
  },
  {
    "label": "无忧物流",
    "value": "aliexpress"
  },
  {
    "label": "嘉里大通",
    "value": "jialidatong"
  },
  {
    "label": "荣庆物流",
    "value": "rokin"
  },
  {
    "label": "中迅三方",
    "value": "cd3fwl"
  },
  {
    "label": "泰进物流",
    "value": "taijin"
  },
  {
    "label": "平安达腾飞",
    "value": "pingandatengfei"
  },
  {
    "label": "苏宁物流",
    "value": "suning"
  },
  {
    "label": "COE",
    "value": "coe"
  },
  {
    "label": "耀飞同城快递",
    "value": "yaofeikuaidi"
  },
  {
    "label": "芝麻开门",
    "value": "zhimakaimen"
  },
  {
    "label": "极地快递",
    "value": "polarexpress"
  },
  {
    "label": "天马迅达",
    "value": "tianma"
  },
  {
    "label": "泛捷国际速递",
    "value": "epanex"
  },
  {
    "label": "速通物流",
    "value": "sut56"
  },
  {
    "label": "EMS包裹",
    "value": "emsbg"
  },
  {
    "label": "安信达",
    "value": "anxindakuaixi"
  },
  {
    "label": "比利时（Bpost）",
    "value": "bpost"
  },
  {
    "label": "黑猫宅急便",
    "value": "tcat"
  },
  {
    "label": "安迅物流",
    "value": "anxl"
  },
  {
    "label": "疯狂快递",
    "value": "crazyexpress"
  },
  {
    "label": "金岸物流",
    "value": "jinan"
  },
  {
    "label": "中速快递",
    "value": "zhongsukuaidi"
  },
  {
    "label": "斑马物流",
    "value": "banma"
  },
  {
    "label": "荷兰邮政-中文(PostNL international registered mail)",
    "value": "postnlcn"
  },
  {
    "label": "澳天速运",
    "value": "aotsd"
  },
  {
    "label": "鼎润物流",
    "value": "la911"
  },
  {
    "label": "微特派",
    "value": "weitepai"
  },
  {
    "label": "Superb Express",
    "value": "superb"
  },
  {
    "label": "Purolator",
    "value": "purolator"
  },
  {
    "label": "DPD UK",
    "value": "dpduk"
  },
  {
    "label": "优邦速运",
    "value": "ubonex"
  },
  {
    "label": "富腾达国际货运",
    "value": "ftd"
  },
  {
    "label": "华翰物流",
    "value": "huahanwuliu"
  },
  {
    "label": "日本郵便",
    "value": "japanpost"
  },
  {
    "label": "商桥物流",
    "value": "shangqiao56"
  },
  {
    "label": "长江国际速递",
    "value": "changjiang"
  },
  {
    "label": "OCS",
    "value": "ocs"
  },
  {
    "label": "联合速运",
    "value": "unitedex"
  },
  {
    "label": "递四方美国",
    "value": "disifangus"
  },
  {
    "label": "澳德物流",
    "value": "auod"
  },
  {
    "label": "科捷物流",
    "value": "kejie"
  },
  {
    "label": "佐川急便",
    "value": "sagawa"
  },
  {
    "label": "中铁飞豹",
    "value": "zhongtiewuliu"
  },
  {
    "label": "中国邮政（CHINA POST）",
    "value": "chinapost"
  },
  {
    "label": "广东邮政",
    "value": "guangdongyouzhengwuliu"
  },
  {
    "label": "三象速递",
    "value": "sxexpress"
  },
  {
    "label": "大田物流",
    "value": "datianwuliu"
  },
  {
    "label": "国通快递",
    "value": "guotongkuaidi"
  },
  {
    "label": "新杰物流",
    "value": "sunjex"
  },
  {
    "label": "佳怡物流",
    "value": "jiayiwuliu"
  },
  {
    "label": "快捷速递",
    "value": "kuaijiesudi"
  },
  {
    "label": "TransRush",
    "value": "transrush"
  },
  {
    "label": "TNT Australia",
    "value": "tntau"
  },
  {
    "label": "贰仟家物流",
    "value": "erqianjia56"
  },
  {
    "label": "家家通快递",
    "value": "newsway"
  },
  {
    "label": "程光快递",
    "value": "flyway"
  },
  {
    "label": "达发物流",
    "value": "dfwl"
  },
  {
    "label": "MoreLink",
    "value": "morelink56"
  },
  {
    "label": "百腾物流",
    "value": "baitengwuliu"
  },
  {
    "label": "EMS物流",
    "value": "emswuliu"
  },
  {
    "label": "佳成快递 ",
    "value": "jiacheng"
  },
  {
    "label": "鸿泰物流",
    "value": "hnht56"
  },
  {
    "label": "Aramex",
    "value": "aramex"
  },
  {
    "label": "加拿大龙行速运",
    "value": "longcps"
  },
  {
    "label": "中邮速递",
    "value": "wondersyd"
  },
  {
    "label": "海欣斯快递",
    "value": "highsince"
  },
  {
    "label": "韵达国际",
    "value": "udalogistic"
  },
  {
    "label": "迅达速递",
    "value": "xdexpress"
  },
  {
    "label": "全联速运",
    "value": "guexp"
  },
  {
    "label": "铁中快运",
    "value": "tzky"
  },
  {
    "label": "三真驿道",
    "value": "zlink"
  },
  {
    "label": "中华邮政",
    "value": "postserv"
  },
  {
    "label": "优优速递",
    "value": "youyou"
  },
  {
    "label": "澳大利亚(Australia Post)",
    "value": "auspost"
  },
  {
    "label": "成都立即送",
    "value": "lijisong"
  },
  {
    "label": "速派快递",
    "value": "fastgoexpress"
  },
  {
    "label": "TST速运通",
    "value": "tstexp"
  },
  {
    "label": "三志物流",
    "value": "sanzhi56"
  },
  {
    "label": "TNT Italy",
    "value": "tntitaly"
  },
  {
    "label": "转运中国",
    "value": "uszcn"
  },
  {
    "label": "宅急便",
    "value": "zhaijibian"
  },
  {
    "label": "源安达",
    "value": "yuananda"
  },
  {
    "label": "速递中国",
    "value": "sendtochina"
  },
  {
    "label": "顺捷美中速递",
    "value": "passerbyaexpress"
  },
  {
    "label": "御风速运",
    "value": "yufeng"
  },
  {
    "label": "飞洋快递",
    "value": "shipgce"
  },
  {
    "label": "万家物流",
    "value": "wanjiawuliu"
  },
  {
    "label": "聚盟共建",
    "value": "jumstc"
  },
  {
    "label": "新元国际",
    "value": "xynyc"
  },
  {
    "label": "新西兰（New Zealand Post）",
    "value": "newzealand"
  },
  {
    "label": "顺丰-荷兰",
    "value": "shunfengnl"
  },
  {
    "label": "美通",
    "value": "valueway"
  },
  {
    "label": "YDH",
    "value": "ydhex"
  },
  {
    "label": "百福东方",
    "value": "baifudongfang"
  },
  {
    "label": "合众速递(UCS）",
    "value": "ucs"
  },
  {
    "label": "速达通",
    "value": "sdto"
  },
  {
    "label": "黄马甲",
    "value": "huangmajia"
  },
  {
    "label": "德国优拜物流",
    "value": "ubuy"
  },
  {
    "label": "邮邦国际",
    "value": "youban"
  },
  {
    "label": "中环快递",
    "value": "zhonghuan"
  },
  {
    "label": "飞远配送",
    "value": "feiyuanvipshop"
  },
  {
    "label": "品骏快递",
    "value": "pjbest"
  },
  {
    "label": "EMS-国际件-英文",
    "value": "emsinten"
  },
  {
    "label": "Austa国际速递",
    "value": "austa"
  },
  {
    "label": "顺丰-繁体",
    "value": "shunfenghk"
  },
  {
    "label": "明达国际速递",
    "value": "tmwexpress"
  },
  {
    "label": "安达速递",
    "value": "adapost"
  },
  {
    "label": "安鲜达",
    "value": "exfresh"
  },
  {
    "label": "E2G速递",
    "value": "express2global"
  },
  {
    "label": "陪行物流",
    "value": "peixingwuliu"
  },
  {
    "label": "中邮物流",
    "value": "zhongyouwuliu"
  },
  {
    "label": "城际快递",
    "value": "chengji"
  },
  {
    "label": "汇通天下物流",
    "value": "httx56"
  },
  {
    "label": "美乐维冷链物流",
    "value": "mlw"
  },
  {
    "label": "百事亨通",
    "value": "bsht"
  },
  {
    "label": "OC-Post",
    "value": "ocpost"
  },
  {
    "label": "荷兰邮政-中国件",
    "value": "postnlchina"
  },
  {
    "label": "亚洲顺物流",
    "value": "yzswuliu"
  },
  {
    "label": "法国小包（colissimo）",
    "value": "colissimo"
  },
  {
    "label": "beiou express",
    "value": "beiou"
  },
  {
    "label": "安捷物流",
    "value": "anjie88"
  },
  {
    "label": "airpak expresss",
    "value": "airpak"
  },
  {
    "label": "永昌物流",
    "value": "yongchangwuliu"
  },
  {
    "label": "友家速递",
    "value": "youjia"
  },
  {
    "label": "德国(Deutsche Post)",
    "value": "deutschepost"
  },
  {
    "label": "Hermes",
    "value": "hermes"
  },
  {
    "label": "艾姆勒",
    "value": "imlb2c"
  },
  {
    "label": "佰麒快递",
    "value": "beckygo"
  },
  {
    "label": "DPEX",
    "value": "dpex"
  },
  {
    "label": "能达速递",
    "value": "ganzhongnengda"
  },
  {
    "label": "USPSCN",
    "value": "uspscn"
  },
  {
    "label": "广州安能聚创物流",
    "value": "gzanjcwl"
  },
  {
    "label": "快捷快物流",
    "value": "gdkjk56"
  },
  {
    "label": "秦远物流",
    "value": "qinyuan"
  },
  {
    "label": "签收快递",
    "value": "signedexpress"
  },
  {
    "label": "美七国际快递",
    "value": "usa7ex"
  },
  {
    "label": "联合速递",
    "value": "lhexpressus"
  },
  {
    "label": "明通国际快递",
    "value": "tnjex"
  },
  {
    "label": "北京EMS",
    "value": "bjemstckj"
  },
  {
    "label": "城晓国际快递",
    "value": "ckeex"
  },
  {
    "label": "顺达快递",
    "value": "sundarexpress"
  },
  {
    "label": "转瞬达集运",
    "value": "zsda56"
  },
  {
    "label": "CNE",
    "value": "cnexps"
  },
  {
    "label": "DHL-德国件（DHL Deutschland）",
    "value": "dhlde"
  },
  {
    "label": "嘉贤物流",
    "value": "jiaxianwuliu"
  },
  {
    "label": "洋包裹",
    "value": "yangbaoguo"
  },
  {
    "label": "中集冷云",
    "value": "cccc58"
  },
  {
    "label": "中外运",
    "value": "esinotrans"
  },
  {
    "label": "中国澳门(Macau Post)",
    "value": "macao"
  },
  {
    "label": "万象物流",
    "value": "wanxiangwuliu"
  },
  {
    "label": "锋鸟物流",
    "value": "beebird"
  },
  {
    "label": "小飞侠速递",
    "value": "cyxfx"
  },
  {
    "label": "星云速递",
    "value": "nebuex"
  },
  {
    "label": "一正达速运",
    "value": "yizhengdasuyun"
  },
  {
    "label": "顺丰冷链",
    "value": "shunfenglengyun"
  },
  {
    "label": "增益速递",
    "value": "zengyisudi"
  },
  {
    "label": "大韩通运",
    "value": "cjkoreaexpress"
  },
  {
    "label": "商壹国际物流",
    "value": "com1express"
  },
  {
    "label": "直德邮",
    "value": "zdepost"
  },
  {
    "label": "锦程快递",
    "value": "hrex"
  },
  {
    "label": "迅速快递",
    "value": "xunsuexpress"
  },
  {
    "label": "亚风速递",
    "value": "yafengsudi"
  },
  {
    "label": "昌宇国际",
    "value": "changwooair"
  },
  {
    "label": "dhl小包",
    "value": "dhlecommerce"
  },
  {
    "label": "皮牙子快递",
    "value": "bazirim"
  },
  {
    "label": "美西快递",
    "value": "meixi"
  },
  {
    "label": "加拿大(Canada Post)",
    "value": "canpost"
  },
  {
    "label": "时达通",
    "value": "jssdt56"
  },
  {
    "label": "春风物流",
    "value": "spring56"
  },
  {
    "label": "中途速递",
    "value": "ztcce"
  },
  {
    "label": "雪域易购",
    "value": "qhxyyg"
  },
  {
    "label": "景顺物流",
    "value": "jingshun"
  },
  {
    "label": "EASY EXPRESS",
    "value": "easyexpress"
  },
  {
    "label": "中国香港(HongKong Post)",
    "value": "hkpost"
  },
  {
    "label": "佳吉快运",
    "value": "jiajiwuliu"
  },
  {
    "label": "宇佳物流",
    "value": "yujiawl"
  },
  {
    "label": "上海缤纷物流",
    "value": "bflg"
  },
  {
    "label": "中国香港环球快运",
    "value": "huanqiuabc"
  },
  {
    "label": "南方传媒物流",
    "value": "ndwl"
  },
  {
    "label": "传喜物流",
    "value": "chuanxiwuliu"
  },
  {
    "label": "海带宝",
    "value": "haidaibao"
  },
  {
    "label": "魔速达",
    "value": "mosuda"
  },
  {
    "label": "百米快运",
    "value": "100mexpress"
  },
  {
    "label": "快达物流",
    "value": "kuaidawuliu"
  },
  {
    "label": "泰国138国际物流",
    "value": "sd138"
  },
  {
    "label": "EMS-英文",
    "value": "emsen"
  },
  {
    "label": "欧亚专线",
    "value": "euasia"
  },
  {
    "label": "快卡",
    "value": "kuaika"
  },
  {
    "label": "腾达速递",
    "value": "nntengda"
  },
  {
    "label": "英国大包、EMS（Parcel Force）",
    "value": "parcelforce"
  },
  {
    "label": "捷祥物流",
    "value": "cdjx56"
  },
  {
    "label": "驿将快运",
    "value": "yijiangky"
  },
  {
    "label": "DPD Poland",
    "value": "dpdpoland"
  },
  {
    "label": "法国大包、EMS-英文(Chronopost France)",
    "value": "chronopostfren"
  },
  {
    "label": "西班牙(Correos de Espa?a)",
    "value": "correosdees"
  },
  {
    "label": "西游寄",
    "value": "xiyoug"
  },
  {
    "label": "一智通",
    "value": "1ziton"
  },
  {
    "label": "华欣物流",
    "value": "chinastarlogistics"
  },
  {
    "label": "一起送",
    "value": "yiqisong"
  },
  {
    "label": "银雁专送",
    "value": "cfss"
  },
  {
    "label": "汇峰物流",
    "value": "huif56"
  },
  {
    "label": "FedEx-美国件",
    "value": "fedexus"
  },
  {
    "label": "人人转运",
    "value": "renrenex"
  },
  {
    "label": "武汉优进汇",
    "value": "yjhgo"
  },
  {
    "label": "帮帮发",
    "value": "bangbangpost"
  },
  {
    "label": "法国(La Poste)",
    "value": "csuivi"
  },
  {
    "label": "聚鼎物流",
    "value": "juding"
  },
  {
    "label": "运通中港",
    "value": "yuntongkuaidi"
  },
  {
    "label": "集先锋快递",
    "value": "jxfex"
  },
  {
    "label": "顺捷丰达",
    "value": "shunjiefengda"
  },
  {
    "label": "优速通达",
    "value": "yousutongda"
  },
  {
    "label": "EFS Post（平安快递）",
    "value": "efs"
  },
  {
    "label": "天天快物流",
    "value": "guoeryue"
  },
  {
    "label": "黑猫同城送",
    "value": "ynztsy"
  },
  {
    "label": "GTS快递",
    "value": "gts"
  },
  {
    "label": "中国香港(HongKong Post)英文",
    "value": "hkposten"
  },
  {
    "label": "新西兰中通",
    "value": "nzzto"
  },
  {
    "label": "一速递",
    "value": "oneexpress"
  },
  {
    "label": "泰国邮政（Thailand Thai Post）",
    "value": "thailand"
  },
  {
    "label": "易境达国际物流",
    "value": "uscbexpress"
  },
  {
    "label": "联邦快递-英文",
    "value": "lianbangkuaidien"
  },
  {
    "label": "易达通快递",
    "value": "qexpress"
  },
  {
    "label": "奉天物流",
    "value": "fengtianexpress"
  },
  {
    "label": "丰通快运",
    "value": "ftky365"
  },
  {
    "label": "Newgistics",
    "value": "newgistics"
  },
  {
    "label": "丹麦(Post Denmark)",
    "value": "postdanmarken"
  },
  {
    "label": "全速物流",
    "value": "quansu"
  },
  {
    "label": "DHL Benelux",
    "value": "dhlbenelux"
  },
  {
    "label": "环球速运",
    "value": "huanqiu"
  },
  {
    "label": "鑫宸物流",
    "value": "cdxinchen56"
  },
  {
    "label": "拉脱维亚(Latvijas Pasts)",
    "value": "latvia"
  },
  {
    "label": "创运物流",
    "value": "zjcy56"
  },
  {
    "label": "飞豹快递",
    "value": "feibaokuaidi"
  },
  {
    "label": "云邮跨境快递",
    "value": "hkems"
  },
  {
    "label": "天翼快递",
    "value": "tykd"
  },
  {
    "label": "全球快运",
    "value": "abcglobal"
  },
  {
    "label": "递五方云仓",
    "value": "di5pll"
  },
  {
    "label": "丰程物流",
    "value": "sccod"
  },
  {
    "label": "宜送物流",
    "value": "yiex"
  },
  {
    "label": "奔腾物流",
    "value": "benteng"
  },
  {
    "label": "速舟物流",
    "value": "cnspeedster"
  },
  {
    "label": "韩国（Korea Post）",
    "value": "koreapost"
  },
  {
    "label": "全川物流",
    "value": "quanchuan56"
  },
  {
    "label": "泰实货运",
    "value": "tjkjwl"
  },
  {
    "label": "Toll Priority(Toll Online)",
    "value": "tollpriority"
  },
  {
    "label": "日日顺智慧物联",
    "value": "gooday365"
  },
  {
    "label": "全一快递",
    "value": "quanyikuaidi"
  },
  {
    "label": "天天欧洲物流",
    "value": "ttkeurope"
  },
  {
    "label": "贝业物流",
    "value": "boyol"
  },
  {
    "label": "汇捷物流",
    "value": "hjwl"
  },
  {
    "label": "如家国际快递",
    "value": "homecourier"
  },
  {
    "label": "佳辰国际速递",
    "value": "jiachenexpress"
  },
  {
    "label": "永邦国际物流",
    "value": "yongbangwuliu"
  },
  {
    "label": "远成物流",
    "value": "yuanchengwuliu"
  },
  {
    "label": "恒路物流",
    "value": "hengluwuliu"
  },
  {
    "label": "捷邦物流",
    "value": "jieborne"
  },
  {
    "label": "运通中港快递",
    "value": "ytkd"
  },
  {
    "label": "中融泰隆",
    "value": "zrtl"
  },
  {
    "label": "群航国际物流",
    "value": "cloudlogistics365"
  },
  {
    "label": "瀚朝物流",
    "value": "hac56"
  },
  {
    "label": "全峰快递",
    "value": "quanfengkuaidi"
  },
  {
    "label": "上大物流",
    "value": "shangda"
  },
  {
    "label": "山西建华",
    "value": "shanxijianhua"
  },
  {
    "label": "TRAKPAK",
    "value": "trakpak"
  },
  {
    "label": "澳州顺风快递",
    "value": "emms"
  },
  {
    "label": "颿达国际快递",
    "value": "fardarww"
  },
  {
    "label": "汇霖大货网",
    "value": "huilin56"
  },
  {
    "label": "秦邦快运",
    "value": "qbexpress"
  },
  {
    "label": "申通新西兰",
    "value": "stonewzealand"
  },
  {
    "label": "世华通物流",
    "value": "szshihuatong56"
  },
  {
    "label": "哥斯达黎加(Correos de Costa Rica)",
    "value": "correos"
  },
  {
    "label": "海红网送",
    "value": "haihongwangsong"
  },
  {
    "label": "CNUP 中联邮",
    "value": "cnup"
  },
  {
    "label": "晟邦物流",
    "value": "nanjingshengbang"
  },
  {
    "label": "远盾物流",
    "value": "yuandun"
  },
  {
    "label": "邦送物流",
    "value": "bangsongwuliu"
  },
  {
    "label": "法国大包、EMS-法文（Chronopost France）",
    "value": "chronopostfra"
  },
  {
    "label": "海联快递",
    "value": "hltop"
  },
  {
    "label": "海派国际速递",
    "value": "hpexpress"
  },
  {
    "label": "中外运速递",
    "value": "zhongwaiyun"
  },
  {
    "label": "amazon-国际订单",
    "value": "amusorder"
  },
  {
    "label": "百世国际",
    "value": "baishiguoji"
  },
  {
    "label": "丹递56",
    "value": "dande56"
  },
  {
    "label": "凤凰快递",
    "value": "fenghuangkuaidi"
  },
  {
    "label": "GSM",
    "value": "gsm"
  },
  {
    "label": "汇达物流",
    "value": "hdcexpress"
  },
  {
    "label": "好来运",
    "value": "hlyex"
  },
  {
    "label": "大马鹿",
    "value": "idamalu"
  },
  {
    "label": "远成快运",
    "value": "ycgky"
  },
  {
    "label": "洋口岸",
    "value": "ykouan"
  },
  {
    "label": "运通速运",
    "value": "yuntong"
  },
  {
    "label": "澳世速递",
    "value": "ausexpress"
  },
  {
    "label": "globaltracktrace",
    "value": "globaltracktrace"
  },
  {
    "label": "意大利(Poste Italiane)",
    "value": "italiane"
  },
  {
    "label": "JDIEX",
    "value": "jdiex"
  },
  {
    "label": "恒通快递",
    "value": "lqht"
  },
  {
    "label": "皇家物流",
    "value": "pfcexpress"
  },
  {
    "label": "美国申通",
    "value": "stoexpress"
  },
  {
    "label": "51跨境通",
    "value": "wykjt"
  },
  {
    "label": "云达通",
    "value": "ydglobe"
  },
  {
    "label": "比利时国际(Bpost international)",
    "value": "bpostinter"
  },
  {
    "label": "巴西(Brazil Post/Correios)",
    "value": "brazilposten"
  },
  {
    "label": "大洋物流",
    "value": "dayangwuliu"
  },
  {
    "label": "E速达",
    "value": "exsuda"
  },
  {
    "label": "泛远国际物流",
    "value": "farlogistis"
  },
  {
    "label": "领送送",
    "value": "lingsong"
  },
  {
    "label": "阿森迪亚",
    "value": "asendia"
  },
  {
    "label": "比利时(Belgium Post)",
    "value": "belgiumpost"
  },
  {
    "label": "爱拜物流",
    "value": "ibuy8"
  },
  {
    "label": "锦程物流",
    "value": "jinchengwuliu"
  },
  {
    "label": "货运皇",
    "value": "kingfreight"
  },
  {
    "label": "浩博物流",
    "value": "njhaobo"
  },
  {
    "label": "新速航",
    "value": "sunspeedy"
  },
  {
    "label": "联运通物流",
    "value": "szuem"
  },
  {
    "label": "UEQ快递",
    "value": "ueq"
  },
  {
    "label": "承诺达",
    "value": "ytchengnuoda"
  },
  {
    "label": "原飞航",
    "value": "yuanfeihangwuliu"
  },
  {
    "label": "牙买加（Jamaica Post）",
    "value": "jamaicapost"
  },
  {
    "label": "龙枫国际快递",
    "value": "lfexpress"
  },
  {
    "label": "全日通",
    "value": "quanritongkuaidi"
  },
  {
    "label": "瑞典（Sweden Post）",
    "value": "ruidianyouzheng"
  },
  {
    "label": "顺捷达",
    "value": "shunjieda"
  },
  {
    "label": "新加坡EMS、大包(Singapore Speedpost)",
    "value": "speedpost"
  },
  {
    "label": "顺通快递",
    "value": "stkd"
  },
  {
    "label": "宇捷通",
    "value": "yujtong"
  },
  {
    "label": "智通物流",
    "value": "ztong"
  },
  {
    "label": "amazon-国内订单",
    "value": "amcnorder"
  },
  {
    "label": "青岛安捷快递",
    "value": "anjiekuaidi"
  },
  {
    "label": "安世通快递",
    "value": "astexpress"
  },
  {
    "label": "CDEK",
    "value": "cdek"
  },
  {
    "label": "CEVA Logistic",
    "value": "cevalogistics"
  },
  {
    "label": "创一快递",
    "value": "chuangyi"
  },
  {
    "label": "德中快递",
    "value": "decnlh"
  },
  {
    "label": "加拿大联通快运",
    "value": "fastontime"
  },
  {
    "label": "嘉诚速达",
    "value": "jcsuda"
  },
  {
    "label": "LaserShip",
    "value": "lasership"
  },
  {
    "label": "巴基斯坦(Pakistan Post)",
    "value": "pakistan"
  },
  {
    "label": "rpx",
    "value": "rpx"
  },
  {
    "label": "闪货极速达",
    "value": "shanhuodidi"
  },
  {
    "label": "八达通",
    "value": "bdatong"
  },
  {
    "label": "彪记快递",
    "value": "biaojikuaidi"
  },
  {
    "label": "CCES/国通快递",
    "value": "cces"
  },
  {
    "label": "CHS中环国际快递",
    "value": "chszhonghuanguoji"
  },
  {
    "label": "7号速递",
    "value": "express7th"
  },
  {
    "label": "高捷快运",
    "value": "goldjet"
  },
  {
    "label": "红远物流",
    "value": "hongywl"
  },
  {
    "label": "汇强快递",
    "value": "huiqiangkuaidi"
  },
  {
    "label": "韩国邮政韩文",
    "value": "koreapostkr"
  },
  {
    "label": "6LS EXPRESS",
    "value": "lsexpress"
  },
  {
    "label": "民航快递",
    "value": "minghangkuaidi"
  },
  {
    "label": "俄罗斯邮政(Russian Post)",
    "value": "pochta"
  },
  {
    "label": "全速通",
    "value": "quansutong"
  },
  {
    "label": "林道国际快递",
    "value": "shlindao"
  },
  {
    "label": "伍圆速递",
    "value": "wuyuansudi"
  },
  {
    "label": "中联速递",
    "value": "auvanda"
  },
  {
    "label": "BHT",
    "value": "bht"
  },
  {
    "label": "河北橙配",
    "value": "chengpei"
  },
  {
    "label": "诚和通",
    "value": "cht361"
  },
  {
    "label": "长吉物流",
    "value": "cjqy"
  },
  {
    "label": "澳通华人物流",
    "value": "cllexpress"
  },
  {
    "label": "华中快递",
    "value": "cpsair"
  },
  {
    "label": "Toll",
    "value": "dpexen"
  },
  {
    "label": "E跨通",
    "value": "ecallturn"
  },
  {
    "label": "海星桥快递",
    "value": "haixingqiao"
  },
  {
    "label": "佳吉快递",
    "value": "jiajikuaidi"
  },
  {
    "label": "金大物流",
    "value": "jindawuliu"
  },
  {
    "label": "骏丰国际速递",
    "value": "junfengguoji"
  },
  {
    "label": "美泰物流",
    "value": "meitai"
  },
  {
    "label": "荷兰包裹(PostNL International Parcels)",
    "value": "postnlpacle"
  },
  {
    "label": "速风快递",
    "value": "sufengkuaidi"
  },
  {
    "label": "穗佳物流",
    "value": "suijiawuliu"
  },
  {
    "label": "瑞士(Swiss Post)",
    "value": "swisspost"
  },
  {
    "label": "优海国际速递",
    "value": "uhi"
  },
  {
    "label": "万家康物流",
    "value": "wjkwl"
  },
  {
    "label": "翔腾物流",
    "value": "xiangteng"
  },
  {
    "label": "元智捷诚",
    "value": "yuanzhijiecheng"
  },
  {
    "label": "招金精炼",
    "value": "zhaojin"
  },
  {
    "label": "中宏物流",
    "value": "zhonghongwl"
  },
  {
    "label": "亚马逊中国订单",
    "value": "amazoncnorder"
  },
  {
    "label": "Asendia USA",
    "value": "asendiausa"
  },
  {
    "label": "青云物流",
    "value": "bjqywl"
  },
  {
    "label": "飞康达",
    "value": "feikangda"
  },
  {
    "label": "飞力士物流",
    "value": "flysman"
  },
  {
    "label": "全网物流",
    "value": "gdqwwl"
  },
  {
    "label": "华美快递",
    "value": "hmus"
  },
  {
    "label": "顺时达物流",
    "value": "hnssd56"
  },
  {
    "label": "捷安达",
    "value": "jieanda"
  },
  {
    "label": "J&T Express 新加坡",
    "value": "jtexpresssg"
  },
  {
    "label": "美国快递",
    "value": "meiguokuaidi"
  },
  {
    "label": "OnTrac",
    "value": "ontrac"
  },
  {
    "label": "PCA Express",
    "value": "pcaexpress"
  },
  {
    "label": "葡萄牙（Portugal CTT）",
    "value": "portugalctt"
  },
  {
    "label": "PostNord(Posten AB)",
    "value": "postenab"
  },
  {
    "label": "急顺通",
    "value": "pzhjst"
  },
  {
    "label": "中加国际快递",
    "value": "scic"
  },
  {
    "label": "TNT Post",
    "value": "tntpostcn"
  },
  {
    "label": "乌克兰邮政包裹",
    "value": "ukrpostcn"
  },
  {
    "label": "亚马逊中国",
    "value": "yamaxunwuliu"
  },
  {
    "label": "西安运逸快递",
    "value": "yyexp"
  },
  {
    "label": "A2U速递",
    "value": "a2u"
  },
  {
    "label": "ADP国际快递",
    "value": "adp"
  },
  {
    "label": "心怡物流",
    "value": "alog"
  },
  {
    "label": "奥地利(Austrian Post)",
    "value": "austria"
  },
  {
    "label": "城市映急",
    "value": "city56"
  },
  {
    "label": "哥伦比亚(4-72 La Red Postal de Colombia)",
    "value": "colombia"
  },
  {
    "label": "大道物流",
    "value": "dadaoex"
  },
  {
    "label": "凡宇快递",
    "value": "fanyukuaidi"
  },
  {
    "label": "安的快递",
    "value": "gda"
  },
  {
    "label": "豪翔物流",
    "value": "haoxiangwuliu"
  },
  {
    "label": "宏捷国际物流",
    "value": "hongjie"
  },
  {
    "label": "林安物流",
    "value": "lasy56"
  },
  {
    "label": "林道国际快递-英文",
    "value": "ldxpres"
  },
  {
    "label": "華信物流WTO",
    "value": "logistics"
  },
  {
    "label": "陆本速递 LUBEN EXPRESS",
    "value": "luben"
  },
  {
    "label": "马来西亚小包（Malaysia Post(Registered)）",
    "value": "malaysiapost"
  },
  {
    "label": "木春货运",
    "value": "mchy"
  },
  {
    "label": "明亮物流",
    "value": "mingliangwuliu"
  },
  {
    "label": "全通快运",
    "value": "quantwl"
  },
  {
    "label": "十方通物流",
    "value": "sfift"
  },
  {
    "label": "圣安物流",
    "value": "shenganwuliu"
  },
  {
    "label": "中外运空运",
    "value": "sinoairinex"
  },
  {
    "label": "中外运速递-中文",
    "value": "sinoex"
  },
  {
    "label": "速呈宅配",
    "value": "sucheng"
  },
  {
    "label": "乌兹别克斯坦(Post of Uzbekistan)",
    "value": "uzbekistan"
  },
  {
    "label": "越南EMS(VNPost Express)",
    "value": "vnpost"
  },
  {
    "label": "祥龙运通物流",
    "value": "xianglongyuntong"
  },
  {
    "label": "也门(Yemen Post)",
    "value": "yemen"
  },
  {
    "label": "英超物流",
    "value": "yingchao"
  },
  {
    "label": "邮来速递",
    "value": "youlai"
  },
  {
    "label": "雅澳物流",
    "value": "yourscm"
  },
  {
    "label": "中天万运",
    "value": "zhongtianwanyun"
  },
  {
    "label": "苏通快运",
    "value": "zjstky"
  },
  {
    "label": "中粮鲜到家物流",
    "value": "zlxdjwl"
  },
  {
    "label": "明辉物流",
    "value": "zsmhwl"
  },
  {
    "label": "ABF",
    "value": "abf"
  },
  {
    "label": "德国雄鹰速递",
    "value": "adlerlogi"
  },
  {
    "label": "加拿大民航快递",
    "value": "airgtc"
  },
  {
    "label": "ARC",
    "value": "arc"
  },
  {
    "label": "阿塞拜疆EMS(EMS AzerExpressPost)",
    "value": "azerbaijan"
  },
  {
    "label": "博茨瓦纳",
    "value": "botspost"
  },
  {
    "label": "文莱(Brunei Postal)",
    "value": "brunei"
  },
  {
    "label": "保加利亚（Bulgarian Posts）",
    "value": "bulgarian"
  },
  {
    "label": "捷克（?eská po?ta）",
    "value": "ceskaposta"
  },
  {
    "label": "City-Link",
    "value": "citylink"
  },
  {
    "label": "CNAIR",
    "value": "cnair"
  },
  {
    "label": "环旅快运",
    "value": "crossbox"
  },
  {
    "label": "深圳德创物流",
    "value": "dechuangwuliu"
  },
  {
    "label": "成都东骏物流",
    "value": "dongjun"
  },
  {
    "label": "联众国际",
    "value": "epspost"
  },
  {
    "label": "Estafeta",
    "value": "estafeta"
  },
  {
    "label": "可可树美中速运",
    "value": "excocotree"
  },
  {
    "label": "飞快达",
    "value": "feikuaida"
  },
  {
    "label": "GHT物流",
    "value": "ghtexpress"
  },
  {
    "label": "共速达",
    "value": "gongsuda"
  },
  {
    "label": "上海航瑞货运",
    "value": "hangrui"
  },
  {
    "label": "华通快运",
    "value": "htongexpress"
  },
  {
    "label": "华企快运",
    "value": "huaqikuaiyun"
  },
  {
    "label": "匈牙利（Magyar Posta）",
    "value": "hungary"
  },
  {
    "label": "鸿远物流",
    "value": "hyeship"
  },
  {
    "label": "恒宇运通",
    "value": "hyytes"
  },
  {
    "label": "极光转运",
    "value": "jiguang"
  },
  {
    "label": "考拉国际速递",
    "value": "kaolaexpress"
  },
  {
    "label": "嘉里大荣物流",
    "value": "kerrytj"
  },
  {
    "label": "柬埔寨中通",
    "value": "khzto"
  },
  {
    "label": "淘韩国际快递",
    "value": "krtao"
  },
  {
    "label": "快速递",
    "value": "ksudi"
  },
  {
    "label": "一号线",
    "value": "lineone"
  },
  {
    "label": "小熊物流",
    "value": "littlebearbear"
  },
  {
    "label": "LUCFLOW EXPRESS",
    "value": "longfx"
  },
  {
    "label": "路邦物流",
    "value": "lubang56"
  },
  {
    "label": "马来西亚大包、EMS（Malaysia Post(parcel,EMS)）",
    "value": "malaysiaems"
  },
  {
    "label": "摩尔多瓦(Posta Moldovei)",
    "value": "moldova"
  },
  {
    "label": "华赫物流",
    "value": "nmhuahe"
  },
  {
    "label": "一号仓",
    "value": "onehcang"
  },
  {
    "label": "北极星快运",
    "value": "polarisexpress"
  },
  {
    "label": "秦岭智能速运",
    "value": "qinling"
  },
  {
    "label": "全时速运",
    "value": "runhengfeng"
  },
  {
    "label": "赛澳递for买卖宝",
    "value": "saiaodimmb"
  },
  {
    "label": "三盛快递",
    "value": "sanshengco"
  },
  {
    "label": "杰响物流",
    "value": "shbwch"
  },
  {
    "label": "新加坡小包(Singapore Post)",
    "value": "singpost"
  },
  {
    "label": "行必达",
    "value": "speeda"
  },
  {
    "label": "速豹",
    "value": "subaoex"
  },
  {
    "label": "速配欧翼",
    "value": "superoz"
  },
  {
    "label": "深圳邮政",
    "value": "szyouzheng"
  },
  {
    "label": "通和天下",
    "value": "tonghetianxia"
  },
  {
    "label": "突尼斯EMS(Rapid-Poste)",
    "value": "tunisia"
  },
  {
    "label": "华夏国际速递",
    "value": "uschuaxia"
  },
  {
    "label": "蓝天物流",
    "value": "xflt56"
  },
  {
    "label": "西邮寄",
    "value": "xipost"
  },
  {
    "label": "迅选物流",
    "value": "xunxuan"
  },
  {
    "label": "易达丰国际速递",
    "value": "ydfexpress"
  },
  {
    "label": "三三国际物流",
    "value": "zenzen"
  },
  {
    "label": "中环转运",
    "value": "zhonghuanus"
  },
  {
    "label": "中技物流",
    "value": "zhongjiwuliu"
  },
  {
    "label": "卓实快运",
    "value": "zhuoshikuaiyun"
  },
  {
    "label": "中通冷链",
    "value": "ztocc"
  },
  {
    "label": "中远快运",
    "value": "zy100"
  },
  {
    "label": "澳捷物流",
    "value": "ajlogistics"
  },
  {
    "label": "安家同城快运",
    "value": "anjiatongcheng"
  },
  {
    "label": "爱尔兰(An Post)",
    "value": "anposten"
  },
  {
    "label": "美国汉邦快递",
    "value": "aplus100"
  },
  {
    "label": "AUV国际快递",
    "value": "auvexpress"
  },
  {
    "label": "百世云配",
    "value": "baishiyp"
  },
  {
    "label": "孟加拉国(EMS)",
    "value": "bangladesh"
  },
  {
    "label": "报通快递",
    "value": "baoxianda"
  },
  {
    "label": "蜜蜂速递",
    "value": "bee001"
  },
  {
    "label": "白俄罗斯(Belpochta)",
    "value": "belpost"
  },
  {
    "label": "BorderGuru",
    "value": "borderguru"
  },
  {
    "label": "百通物流",
    "value": "buytong"
  },
  {
    "label": "加拿大邮政",
    "value": "canpostfr"
  },
  {
    "label": "次晨达物流",
    "value": "ccd"
  },
  {
    "label": "SQK国际速递",
    "value": "chinasqk"
  },
  {
    "label": "嘉荣物流",
    "value": "chllog"
  },
  {
    "label": "中翼国际物流",
    "value": "chnexp"
  },
  {
    "label": "中欧物流",
    "value": "cneulogistics"
  },
  {
    "label": "CNPEX中邮快递",
    "value": "cnpex"
  },
  {
    "label": "中国翼",
    "value": "cnws"
  },
  {
    "label": "阿根廷(Correo Argentina)",
    "value": "correoargentino"
  },
  {
    "label": "泰国中通CTO",
    "value": "ctoexp"
  },
  {
    "label": "云南诚中物流",
    "value": "czwlyn"
  },
  {
    "label": "云南滇驿物流",
    "value": "dianyi"
  },
  {
    "label": "ECMS Express",
    "value": "ecmsglobal"
  },
  {
    "label": "易达快运",
    "value": "edaeuexpress"
  },
  {
    "label": "波兰小包(Poczta Polska)",
    "value": "emonitoring"
  },
  {
    "label": "俄顺达",
    "value": "eshunda"
  },
  {
    "label": "易达国际速递",
    "value": "eta100"
  },
  {
    "label": "ETEEN专线",
    "value": "eteenlog"
  },
  {
    "label": "易邮国际",
    "value": "euguoji"
  },
  {
    "label": "易优包裹",
    "value": "eupackage"
  },
  {
    "label": "易转运",
    "value": "ezhuanyuan"
  },
  {
    "label": "飞邦快递",
    "value": "fbkd"
  },
  {
    "label": "四方格",
    "value": "fourpxus"
  },
  {
    "label": "全速快递",
    "value": "fsexp"
  },
  {
    "label": "法翔速运",
    "value": "ftlexpress"
  },
  {
    "label": "飞云快递系统",
    "value": "fyex"
  },
  {
    "label": "Gati-中文",
    "value": "gaticn"
  },
  {
    "label": "联合快递",
    "value": "gslhkd"
  },
  {
    "label": "万通快递",
    "value": "gswtkd"
  },
  {
    "label": "国送快运",
    "value": "guosong"
  },
  {
    "label": "光线速递",
    "value": "gxwl"
  },
  {
    "label": "海盟速递",
    "value": "haimengsudi"
  },
  {
    "label": "海中转运",
    "value": "haizhongzhuanyun"
  },
  {
    "label": "黑豹物流",
    "value": "heibaowuliu"
  },
  {
    "label": "黑猫速运",
    "value": "heimao56"
  },
  {
    "label": "环国运物流",
    "value": "hgy56"
  },
  {
    "label": "飞豹速递",
    "value": "hkeex"
  },
  {
    "label": "中强物流",
    "value": "hnzqwl"
  },
  {
    "label": "宏品物流",
    "value": "hongpinwuliu"
  },
  {
    "label": "皇家云仓",
    "value": "hotwms"
  },
  {
    "label": "环东物流",
    "value": "huandonglg"
  },
  {
    "label": "华夏货运",
    "value": "huaxiahuoyun"
  },
  {
    "label": "冰岛(Iceland Post)",
    "value": "iceland"
  },
  {
    "label": "大达物流",
    "value": "idada"
  },
  {
    "label": "ID Express",
    "value": "idexpress"
  },
  {
    "label": "印度(India Post)",
    "value": "india"
  },
  {
    "label": "捷运达快递",
    "value": "interjz"
  },
  {
    "label": "以色列(Israel Post)",
    "value": "israelpost"
  },
  {
    "label": "驿扬国际速运",
    "value": "iyoungspeed"
  },
  {
    "label": "jcex",
    "value": "jcex"
  },
  {
    "label": "极兔国际",
    "value": "jet"
  },
  {
    "label": "加州猫速递",
    "value": "jiazhoumao"
  },
  {
    "label": "冀速物流",
    "value": "jisu"
  },
  {
    "label": "九宫物流",
    "value": "jiugong"
  },
  {
    "label": "JNE",
    "value": "jne"
  },
  {
    "label": "哈萨克斯坦(Kazpost)",
    "value": "kazpost"
  },
  {
    "label": "KCS",
    "value": "kcs"
  },
  {
    "label": "快8速运",
    "value": "kuai8"
  },
  {
    "label": "Linex",
    "value": "linex"
  },
  {
    "label": "乐天速递",
    "value": "ltexp"
  },
  {
    "label": "鲁通快运",
    "value": "lutong"
  },
  {
    "label": "LWE",
    "value": "lwe"
  },
  {
    "label": "美达快递",
    "value": "meidaexpress"
  },
  {
    "label": "墨西哥（Correos de Mexico）",
    "value": "mexico"
  },
  {
    "label": "银河物流",
    "value": "milkyway"
  },
  {
    "label": "民邦速递",
    "value": "minbangsudi"
  },
  {
    "label": "美龙快递",
    "value": "mjexp"
  },
  {
    "label": "猛犸速递",
    "value": "mmlogi"
  },
  {
    "label": "尼日利亚(Nigerian Postal)",
    "value": "nigerianpost"
  },
  {
    "label": "偌亚奥国际快递",
    "value": "nuoyaao"
  },
  {
    "label": "波音速递",
    "value": "overseaex"
  },
  {
    "label": "诚一物流",
    "value": "parcelchina"
  },
  {
    "label": "英国邮政大包EMS",
    "value": "parcelforcecn"
  },
  {
    "label": "菲律宾（Philippine Postal）",
    "value": "phlpost"
  },
  {
    "label": "先锋国际快递",
    "value": "pioneer"
  },
  {
    "label": "Portugal Seur",
    "value": "portugalseur"
  },
  {
    "label": "千里速递",
    "value": "qianli"
  },
  {
    "label": "全际通",
    "value": "quanjitong"
  },
  {
    "label": "Quantium",
    "value": "quantium"
  },
  {
    "label": "叙利亚(Syrian Post)",
    "value": "republic"
  },
  {
    "label": "睿和泰速运",
    "value": "rhtexpress"
  },
  {
    "label": "日日顺快线",
    "value": "rrskx"
  },
  {
    "label": "赛澳递",
    "value": "saiaodi"
  },
  {
    "label": "萨摩亚(Samoa Post)",
    "value": "samoa"
  },
  {
    "label": "速佳达快运",
    "value": "scsujiada"
  },
  {
    "label": "上海快通",
    "value": "shanghaikuaitong"
  },
  {
    "label": "盛通快递",
    "value": "shengtongscm"
  },
  {
    "label": "顺士达速运",
    "value": "shunshid"
  },
  {
    "label": "Siodemka",
    "value": "siodemka"
  },
  {
    "label": "skynetworldwide",
    "value": "skynetworldwide"
  },
  {
    "label": "嗖一下同城快递",
    "value": "sofast56"
  },
  {
    "label": "南非（South African Post Office）",
    "value": "southafrican"
  },
  {
    "label": "首通快运",
    "value": "staky"
  },
  {
    "label": "瑞士邮政",
    "value": "swisspostcn"
  },
  {
    "label": "加拿大雷霆快递",
    "value": "thunderexpress"
  },
  {
    "label": "天翔快递",
    "value": "tianxiang"
  },
  {
    "label": "天纵物流",
    "value": "tianzong"
  },
  {
    "label": "万家通快递",
    "value": "timedg"
  },
  {
    "label": "TNT UK",
    "value": "tntuk"
  },
  {
    "label": "中运全速",
    "value": "topspeedex"
  },
  {
    "label": "海龟国际快递",
    "value": "turtle"
  },
  {
    "label": "天翼物流",
    "value": "tywl99"
  },
  {
    "label": "速翼快递",
    "value": "usasueexpress"
  },
  {
    "label": "万庚国际速递",
    "value": "vangenexpress"
  },
  {
    "label": "wedepot物流",
    "value": "wedepot"
  },
  {
    "label": "西翼物流",
    "value": "westwing"
  },
  {
    "label": "五六快运",
    "value": "wuliuky"
  },
  {
    "label": "湘达物流",
    "value": "xiangdawuliu"
  },
  {
    "label": "鑫梦成",
    "value": "xinmengcheng"
  },
  {
    "label": "新宁物流",
    "value": "xinning"
  },
  {
    "label": "西游寄速递",
    "value": "xyjexpress"
  },
  {
    "label": "宇航通物流",
    "value": "yhtlogistics"
  },
  {
    "label": "银捷速递",
    "value": "yinjiesudi"
  },
  {
    "label": "亿顺航",
    "value": "yishunhang"
  },
  {
    "label": "易邮速运",
    "value": "yiyou"
  },
  {
    "label": "益加盛快递",
    "value": "yjs"
  },
  {
    "label": "YODEL",
    "value": "yodel"
  },
  {
    "label": "运通快运",
    "value": "ytky168"
  },
  {
    "label": "玥玛速运",
    "value": "yue777"
  },
  {
    "label": "越丰物流",
    "value": "yuefengwuliu"
  },
  {
    "label": "振捷国际货运",
    "value": "zjgj56"
  },
  {
    "label": "准实快运",
    "value": "zsky123"
  },
  {
    "label": "ZTE中兴物流",
    "value": "zteexpress"
  },
  {
    "label": "泰捷达国际物流",
    "value": "ztjieda"
  },
  {
    "label": "360 Lion Express",
    "value": "360lion"
  },
  {
    "label": "AAA Cooper Transportation",
    "value": "aaacooper"
  },
  {
    "label": "ABS courier & freight system",
    "value": "abs"
  },
  {
    "label": "ABX Express",
    "value": "abxexpress_my"
  },
  {
    "label": "aCommerce",
    "value": "acommerce"
  },
  {
    "label": "ACS Courier",
    "value": "acscourier"
  },
  {
    "label": "明大快递",
    "value": "adaexpress"
  },
  {
    "label": "安达易国际速递",
    "value": "adiexpress"
  },
  {
    "label": "ADSone",
    "value": "adsone"
  },
  {
    "label": "安达信",
    "value": "advancing"
  },
  {
    "label": "阿富汗(Afghan Post)",
    "value": "afghan"
  },
  {
    "label": "AFL",
    "value": "afl"
  },
  {
    "label": "Agility Logistics",
    "value": "agility"
  },
  {
    "label": "全程快递",
    "value": "agopost"
  },
  {
    "label": "德方物流",
    "value": "ahdf"
  },
  {
    "label": "卡邦配送",
    "value": "ahkbps"
  },
  {
    "label": "捷记方舟",
    "value": "ajexpress"
  },
  {
    "label": "奥兰群岛",
    "value": "aland"
  },
  {
    "label": "阿尔巴尼亚(Posta shqipatre)",
    "value": "albania"
  },
  {
    "label": "AlfaTrex",
    "value": "alfatrex"
  },
  {
    "label": "Algeria",
    "value": "algeria"
  },
  {
    "label": "ALLIED",
    "value": "alliedexpress"
  },
  {
    "label": "Swiship UK",
    "value": "amazon_fba_swiship"
  },
  {
    "label": "Anjun Logistics",
    "value": "anjun_logistics"
  },
  {
    "label": "新干线快递",
    "value": "anlexpress"
  },
  {
    "label": "安时递",
    "value": "anshidi"
  },
  {
    "label": "Anteraja",
    "value": "anteraja"
  },
  {
    "label": "AOL澳通速递",
    "value": "aolau"
  },
  {
    "label": "澳速物流",
    "value": "aosu"
  },
  {
    "label": "APC Postal Logistics",
    "value": "apc"
  },
  {
    "label": "apgecommerce",
    "value": "apgecommerce"
  },
  {
    "label": "艾瑞斯远",
    "value": "ariesfar"
  },
  {
    "label": "阿鲁巴[荷兰]（Post Aruba）",
    "value": "aruba"
  },
  {
    "label": "Asendia HK",
    "value": "asendiahk"
  },
  {
    "label": "澳达国际物流",
    "value": "auadexpress"
  },
  {
    "label": "澳货通",
    "value": "auex"
  },
  {
    "label": "澳邦国际物流",
    "value": "ausbondexpress"
  },
  {
    "label": "澳新物流",
    "value": "axexpress"
  },
  {
    "label": "巴林(Bahrain Post)",
    "value": "bahrain"
  },
  {
    "label": "宝通快递",
    "value": "baotongkd"
  },
  {
    "label": "巴巴多斯(Barbados Post)",
    "value": "barbados"
  },
  {
    "label": "BCWELT",
    "value": "bcwelt"
  },
  {
    "label": "BDC快递",
    "value": "bdcgcc"
  },
  {
    "label": "BEE express",
    "value": "beeexpress"
  },
  {
    "label": "伯利兹(Belize Postal)",
    "value": "belize"
  },
  {
    "label": "贝宁",
    "value": "benin"
  },
  {
    "label": "笨鸟国际",
    "value": "benniao"
  },
  {
    "label": "飛斯特",
    "value": "bester"
  },
  {
    "label": "不丹邮政 Bhutan Post",
    "value": "bhutan"
  },
  {
    "label": "鑫锐达",
    "value": "bjxsrd"
  },
  {
    "label": "远通盛源",
    "value": "bjytsywl"
  },
  {
    "label": "佰乐捷通",
    "value": "bljt56"
  },
  {
    "label": "BlueDart",
    "value": "bluedart"
  },
  {
    "label": "标杆物流",
    "value": "bmlchina"
  },
  {
    "label": "波黑(JP BH Posta)",
    "value": "bohei"
  },
  {
    "label": "玻利维亚",
    "value": "bolivia"
  },
  {
    "label": "堡昕德速递",
    "value": "bosind"
  },
  {
    "label": "Bosta",
    "value": "bosta"
  },
  {
    "label": "BOXC",
    "value": "boxc"
  },
  {
    "label": "速方(Sufast)",
    "value": "bphchina"
  },
  {
    "label": "百千诚物流",
    "value": "bqcwl"
  },
  {
    "label": "Bridge Express ",
    "value": "bridgeexpress "
  },
  {
    "label": "宏桥国际物流",
    "value": "briems"
  },
  {
    "label": "BRT",
    "value": "brt"
  },
  {
    "label": "Buylogic",
    "value": "buylogic"
  },
  {
    "label": "展勤快递",
    "value": "byht"
  },
  {
    "label": "新喀里多尼亚[法国](New Caledonia)",
    "value": "caledonia"
  },
  {
    "label": "柬埔寨(Cambodia Post)",
    "value": "cambodia"
  },
  {
    "label": "到了港",
    "value": "camekong"
  },
  {
    "label": "喀麦隆(CAMPOST)",
    "value": "cameroon"
  },
  {
    "label": "Campbell’s Express",
    "value": "campbellsexpress"
  },
  {
    "label": "能装能送",
    "value": "canhold"
  },
  {
    "label": "Canpar",
    "value": "canpar"
  },
  {
    "label": "卢森堡航空",
    "value": "cargolux"
  },
  {
    "label": "CBL Logistica",
    "value": "cbl"
  },
  {
    "label": "CBL Logistics",
    "value": "cbl_logistica"
  },
  {
    "label": "广州信邦",
    "value": "cbllogistics"
  },
  {
    "label": "钏博物流",
    "value": "cbo56"
  },
  {
    "label": "CEVA Logistics",
    "value": "ceva"
  },
  {
    "label": "城铁速递",
    "value": "cex"
  },
  {
    "label": "成达国际速递",
    "value": "chengda"
  },
  {
    "label": "城通物流",
    "value": "chengtong"
  },
  {
    "label": "智利(Correos Chile)",
    "value": "chile"
  },
  {
    "label": "中邮电商",
    "value": "chinapostcb"
  },
  {
    "label": "荣通国际",
    "value": "chinaqingguan"
  },
  {
    "label": "同舟行物流",
    "value": "chinatzx"
  },
  {
    "label": "Chronopost Portugal",
    "value": "chronopostport"
  },
  {
    "label": "中国香港骏辉物流",
    "value": "chunfai"
  },
  {
    "label": "中骅物流",
    "value": "chunghwa56"
  },
  {
    "label": "citysprint",
    "value": "citysprint"
  },
  {
    "label": "CE易欧通国际速递",
    "value": "cloudexpress"
  },
  {
    "label": "CL日中速运",
    "value": "clsp"
  },
  {
    "label": "中澳速递",
    "value": "cnausu"
  },
  {
    "label": "C&C国际速递",
    "value": "cncexp"
  },
  {
    "label": "Collect+",
    "value": "collectplus"
  },
  {
    "label": "邦通国际",
    "value": "comexpress"
  },
  {
    "label": "Corporate couriers logistics",
    "value": "corporatecouriers"
  },
  {
    "label": "莫桑比克（Correios de Moçambique）",
    "value": "correios"
  },
  {
    "label": "乌拉圭（Correo Uruguayo）",
    "value": "correo"
  },
  {
    "label": "Correos Express",
    "value": "correosexpress"
  },
  {
    "label": "CourierPost",
    "value": "courierpost"
  },
  {
    "label": "Couriers Please",
    "value": "couriersplease"
  },
  {
    "label": "重庆星程快递",
    "value": "cqxingcheng"
  },
  {
    "label": "新时速物流",
    "value": "csxss"
  },
  {
    "label": "塞浦路斯(Cyprus Post)",
    "value": "cypruspost"
  },
  {
    "label": "DACHSER",
    "value": "dachser"
  },
  {
    "label": "达速物流",
    "value": "dasu"
  },
  {
    "label": "DCS",
    "value": "dcs"
  },
  {
    "label": "叮当同城",
    "value": "ddotbase"
  },
  {
    "label": "Delhivery",
    "value": "delhivery"
  },
  {
    "label": "Delivery Station",
    "value": "deliverystations"
  },
  {
    "label": "Deltec Courier",
    "value": "deltec"
  },
  {
    "label": "Deploy",
    "value": "deployeg"
  },
  {
    "label": "澳行快递",
    "value": "desworks"
  },
  {
    "label": "东风全球速递",
    "value": "dfglobalex"
  },
  {
    "label": "达方物流",
    "value": "dfpost"
  },
  {
    "label": "DHL HK",
    "value": "dhlhk"
  },
  {
    "label": "DHL-荷兰（DHL Netherlands）",
    "value": "dhlnetherlands"
  },
  {
    "label": "DHL-波兰（DHL Poland）",
    "value": "dhlpoland"
  },
  {
    "label": "dhluk",
    "value": "dhluk"
  },
  {
    "label": "递达速运",
    "value": "didasuyun"
  },
  {
    "label": "叮咚澳洲转运",
    "value": "dindon"
  },
  {
    "label": "叮咚快递",
    "value": "dingdong"
  },
  {
    "label": "Direct Link",
    "value": "directlink"
  },
  {
    "label": "递四方澳洲",
    "value": "disifangau"
  },
  {
    "label": "吉布提",
    "value": "djibouti"
  },
  {
    "label": "天翔东捷运",
    "value": "djy56"
  },
  {
    "label": "东瀚物流",
    "value": "donghanwl"
  },
  {
    "label": "东红物流",
    "value": "donghong"
  },
  {
    "label": "Dotzot",
    "value": "dotzot"
  },
  {
    "label": "DPD Ireland",
    "value": "dpd_ireland"
  },
  {
    "label": "DPE Express",
    "value": "dpe_express"
  },
  {
    "label": "dreevo",
    "value": "dreevo"
  },
  {
    "label": "老司机国际快递",
    "value": "driverfastgo"
  },
  {
    "label": "DSV",
    "value": "dsv"
  },
  {
    "label": "德淘邦",
    "value": "dt8ang"
  },
  {
    "label": "DTD",
    "value": "dtd"
  },
  {
    "label": "DTDC India",
    "value": "dtdcindia"
  },
  {
    "label": "多道供应链",
    "value": "duodao56"
  },
  {
    "label": "大亿快递",
    "value": "dyexpress"
  },
  {
    "label": "东方航空物流",
    "value": "ealceair"
  },
  {
    "label": "EC-Firstclass",
    "value": "ecfirstclass"
  },
  {
    "label": "Echo",
    "value": "echo"
  },
  {
    "label": "Ecom Express",
    "value": "ecomexpress"
  },
  {
    "label": "东西E全运",
    "value": "ecotransite"
  },
  {
    "label": "厄瓜多尔(Correos del Ecuador)",
    "value": "ecuador"
  },
  {
    "label": "龙象国际物流",
    "value": "edragon"
  },
  {
    "label": "e直运",
    "value": "edtexpress"
  },
  {
    "label": "EFSPOST",
    "value": "efspost"
  },
  {
    "label": "EGY Express Logistics",
    "value": "egyexpress"
  },
  {
    "label": "埃及（Egypt Post）",
    "value": "egypt"
  },
  {
    "label": "艾菲尔国际速递",
    "value": "eiffel"
  },
  {
    "label": "Ekart",
    "value": "ekart"
  },
  {
    "label": "易联通达",
    "value": "el56"
  },
  {
    "label": "希腊包裹（ELTA Hellenic Post）",
    "value": "elta"
  },
  {
    "label": "希腊EMS（ELTA Courier）",
    "value": "eltahell"
  },
  {
    "label": "阿联酋(Emirates Post)",
    "value": "emirates"
  },
  {
    "label": "阿联酋(Emirates Post)",
    "value": "emiratesen"
  },
  {
    "label": "波兰小包(Poczta Polska)",
    "value": "emonitoringen"
  },
  {
    "label": "高考通知书",
    "value": "emsluqu"
  },
  {
    "label": "南非EMS",
    "value": "emssouthafrica"
  },
  {
    "label": "乌克兰EMS(EMS Ukraine)",
    "value": "emsukraine"
  },
  {
    "label": "乌克兰EMS-中文(EMS Ukraine)",
    "value": "emsukrainecn"
  },
  {
    "label": "英国(大包,EMS)",
    "value": "england"
  },
  {
    "label": "Equick China",
    "value": "equick_cn"
  },
  {
    "label": "厄立特里亚",
    "value": "eripostal"
  },
  {
    "label": "东方汇",
    "value": "est365"
  },
  {
    "label": "Estes",
    "value": "estes"
  },
  {
    "label": "埃塞俄比亚(Ethiopian postal)",
    "value": "ethiopia"
  },
  {
    "label": "埃塞俄比亚(Ethiopian Post)",
    "value": "ethiopian"
  },
  {
    "label": "E通速递",
    "value": "etong"
  },
  {
    "label": "中欧国际物流",
    "value": "eucnrail"
  },
  {
    "label": "德国 EUC POST",
    "value": "eucpost"
  },
  {
    "label": "EU-EXPRESS",
    "value": "euexpress"
  },
  {
    "label": "败欧洲",
    "value": "europe8"
  },
  {
    "label": "europeanecom",
    "value": "europeanecom"
  },
  {
    "label": "优莎速运",
    "value": "eusacn"
  },
  {
    "label": "飛斯特運通",
    "value": "exbtr"
  },
  {
    "label": "Expeditors",
    "value": "expeditors"
  },
  {
    "label": "探路速运",
    "value": "explorer56"
  },
  {
    "label": "澳洲新干线快递",
    "value": "expressplus"
  },
  {
    "label": "颿达国际快递-英文",
    "value": "fandaguoji"
  },
  {
    "label": "Fastway Ireland",
    "value": "fastway"
  },
  {
    "label": "Fastway New Zealand",
    "value": "fastway_nz"
  },
  {
    "label": "Fastway South Africa",
    "value": "fastway_za"
  },
  {
    "label": "正途供应链",
    "value": "fastzt"
  },
  {
    "label": "FDS",
    "value": "fds"
  },
  {
    "label": "FedEx-英国件（FedEx UK)",
    "value": "fedexuk"
  },
  {
    "label": "FedEx-英国件",
    "value": "fedexukcn"
  },
  {
    "label": "FedRoad 联邦转运",
    "value": "fedroad"
  },
  {
    "label": "飞狐快递",
    "value": "feihukuaidi"
  },
  {
    "label": "丰羿",
    "value": "fengyee"
  },
  {
    "label": "斐济(Fiji Post)",
    "value": "fiji"
  },
  {
    "label": "芬兰(Itella Posti Oy)",
    "value": "finland"
  },
  {
    "label": "First Flight",
    "value": "firstflight"
  },
  {
    "label": "First Logistics",
    "value": "firstlogistics"
  },
  {
    "label": "Flash Express",
    "value": "flashexpress"
  },
  {
    "label": "Flash Express-英文",
    "value": "flashexpressen"
  },
  {
    "label": "Flextock",
    "value": "flextock"
  },
  {
    "label": "花瓣转运",
    "value": "flowerkd"
  },
  {
    "label": "FODEL",
    "value": "fodel"
  },
  {
    "label": "FOX国际快递",
    "value": "fox"
  },
  {
    "label": "FQ狂派速递",
    "value": "freakyquick"
  },
  {
    "label": "高铁快运",
    "value": "gaotieex"
  },
  {
    "label": "Gati-英文",
    "value": "gatien"
  },
  {
    "label": "Gati-KWE",
    "value": "gatikwe"
  },
  {
    "label": "广东诚通物流",
    "value": "gdct56"
  },
  {
    "label": "GDEX",
    "value": "gdex"
  },
  {
    "label": "容智快运",
    "value": "gdrz58"
  },
  {
    "label": "新鹏快递",
    "value": "gdxp"
  },
  {
    "label": "GE2D跨境物流",
    "value": "ge2d"
  },
  {
    "label": "格鲁吉亚(Georgian Pos）",
    "value": "georgianpost"
  },
  {
    "label": "G EXpress",
    "value": "gexpress"
  },
  {
    "label": "加纳",
    "value": "ghanapost"
  },
  {
    "label": "环创物流",
    "value": "ghl"
  },
  {
    "label": "直布罗陀[英国]( Royal Gibraltar Post)",
    "value": "gibraltar"
  },
  {
    "label": "GIZTIX",
    "value": "giztix"
  },
  {
    "label": "冠捷物流 ",
    "value": "gjwl"
  },
  {
    "label": "全球特快",
    "value": "global99"
  },
  {
    "label": "GLS Italy",
    "value": "gls_italy"
  },
  {
    "label": "英脉物流",
    "value": "gml"
  },
  {
    "label": "GOGOX",
    "value": "gogox"
  },
  {
    "label": "gojavas",
    "value": "gojavas"
  },
  {
    "label": "Grab",
    "value": "grab"
  },
  {
    "label": "格陵兰[丹麦]（TELE Greenland A/S）",
    "value": "greenland"
  },
  {
    "label": "潍鸿",
    "value": "grivertek"
  },
  {
    "label": "哥士传奇速递",
    "value": "gscq365"
  },
  {
    "label": "德尚国际速递",
    "value": "gslexpress"
  },
  {
    "label": "GT国际快运",
    "value": "gtgogo"
  },
  {
    "label": "GTT EXPRESS快递",
    "value": "gttexpress"
  },
  {
    "label": "广东通路",
    "value": "guangdongtonglu"
  },
  {
    "label": "永邦快递",
    "value": "guangdongyongbang"
  },
  {
    "label": "冠庭国际物流",
    "value": "guanting"
  },
  {
    "label": "根西岛",
    "value": "guernsey"
  },
  {
    "label": "国顺达物流",
    "value": "guoshunda"
  },
  {
    "label": "圭亚那",
    "value": "guyana"
  },
  {
    "label": "宏观国际快递",
    "value": "gvpexpress"
  },
  {
    "label": "贵州星程快递",
    "value": "gzxingcheng"
  },
  {
    "label": "货六六",
    "value": "h66"
  },
  {
    "label": "海红for买卖宝",
    "value": "haihongmmb"
  },
  {
    "label": "汉邦国际速递",
    "value": "handboy"
  },
  {
    "label": "翰丰快递",
    "value": "hanfengjl"
  },
  {
    "label": "航宇快递",
    "value": "hangyu"
  },
  {
    "label": "好又快物流",
    "value": "haoyoukuai"
  },
  {
    "label": "开心快递",
    "value": "happylink"
  },
  {
    "label": "亚美尼亚(Haypost-Armenian Postal)",
    "value": "haypost"
  },
  {
    "label": "恒瑞物流",
    "value": "hengrui56"
  },
  {
    "label": "Hermes Germany",
    "value": "hermes_de"
  },
  {
    "label": "Hermesworld",
    "value": "hermesworld"
  },
  {
    "label": "合心速递",
    "value": "hexinexpress"
  },
  {
    "label": "华瀚快递",
    "value": "hhair56"
  },
  {
    "label": "Highway",
    "value": "highway"
  },
  {
    "label": "Hi淘易快递",
    "value": "hitaoe"
  },
  {
    "label": "猴急送",
    "value": "hjs"
  },
  {
    "label": "互联快运",
    "value": "hlkytj"
  },
  {
    "label": "共联配",
    "value": "hlpgyl"
  },
  {
    "label": "飞鹰物流",
    "value": "hnfy"
  },
  {
    "label": "河南全速通",
    "value": "hnqst"
  },
  {
    "label": "Holisol",
    "value": "holisollogistics"
  },
  {
    "label": "居家通",
    "value": "homexpress"
  },
  {
    "label": "洪都拉斯",
    "value": "honduras"
  },
  {
    "label": "红背心",
    "value": "hongbeixin"
  },
  {
    "label": "环球通达 ",
    "value": "hqtd"
  },
  {
    "label": "卓烨快递",
    "value": "hrbzykd"
  },
  {
    "label": "高铁速递",
    "value": "hre"
  },
  {
    "label": "克罗地亚（Hrvatska Posta）",
    "value": "hrvatska"
  },
  {
    "label": "海硕高铁速递",
    "value": "hsgtsd"
  },
  {
    "label": "海淘物流",
    "value": "ht22"
  },
  {
    "label": "华通务达物流",
    "value": "htwd"
  },
  {
    "label": "华达快运",
    "value": "huada"
  },
  {
    "label": "驼峰国际",
    "value": "humpline"
  },
  {
    "label": "hunter Express",
    "value": "hunterexpress"
  },
  {
    "label": "兰州伙伴物流",
    "value": "huoban"
  },
  {
    "label": "户通物流",
    "value": "hutongwuliu"
  },
  {
    "label": "上海昊宏国际货物",
    "value": "hyk"
  },
  {
    "label": "华航快递",
    "value": "hzpl"
  },
  {
    "label": "IB Courier",
    "value": "ibcourier"
  },
  {
    "label": "泛太优达",
    "value": "iex"
  },
  {
    "label": "iExpress",
    "value": "iexpress"
  },
  {
    "label": "无限速递",
    "value": "igcaexpress"
  },
  {
    "label": "logen路坚",
    "value": "ilogen"
  },
  {
    "label": "ILYANG",
    "value": "ilyang"
  },
  {
    "label": "iMile",
    "value": "imile"
  },
  {
    "label": "印度尼西亚EMS(Pos Indonesia-EMS)",
    "value": "indonesia"
  },
  {
    "label": "INDOPAKET",
    "value": "indopaket"
  },
  {
    "label": "多米尼加（INPOSDOM – Instituto Postal Dominicano）",
    "value": "inposdom"
  },
  {
    "label": "InPost Paczkomaty",
    "value": "inpost_paczkomaty"
  },
  {
    "label": "Interlink Express",
    "value": "interlink"
  },
  {
    "label": "Interparcel",
    "value": "interparcel"
  },
  {
    "label": "UPS i-parcel",
    "value": "iparcel"
  },
  {
    "label": "伊朗（Iran Post）",
    "value": "iran"
  },
  {
    "label": "Italy SDA",
    "value": "italysad"
  },
  {
    "label": "IXPRESS",
    "value": "ixpress"
  },
  {
    "label": "janio",
    "value": "janio"
  },
  {
    "label": "骏达快递",
    "value": "jdexpressusa"
  },
  {
    "label": "急递",
    "value": "jdpplus"
  },
  {
    "label": "泽西岛",
    "value": "jerseypost"
  },
  {
    "label": "Jet Express",
    "value": "jetexpresseg"
  },
  {
    "label": "澳速通国际速递",
    "value": "jetexpressgroup"
  },
  {
    "label": "J&T Express",
    "value": "jetexpresszh"
  },
  {
    "label": "捷仕",
    "value": "jetstarexp"
  },
  {
    "label": "佳家通货运",
    "value": "jiajiatong56"
  },
  {
    "label": "加佳物流",
    "value": "jiajiawl"
  },
  {
    "label": "近端",
    "value": "jinduan"
  },
  {
    "label": "劲通快递",
    "value": "jintongkd"
  },
  {
    "label": "晋越快递",
    "value": "jinyuekuaidi"
  },
  {
    "label": "久久物流",
    "value": "jiujiuwl"
  },
  {
    "label": "久易快递",
    "value": "jiuyicn"
  },
  {
    "label": "急先达",
    "value": "jixianda"
  },
  {
    "label": "吉祥邮（澳洲）",
    "value": "jixiangyouau"
  },
  {
    "label": "佳捷翔物流",
    "value": "jjx888"
  },
  {
    "label": "约旦(Jordan Post)",
    "value": "jordan"
  },
  {
    "label": "骏绅物流",
    "value": "jsexpress"
  },
  {
    "label": "J&T Express 马来西亚",
    "value": "jtexpressmy"
  },
  {
    "label": "J&T Express 泰国",
    "value": "jtexpressth"
  },
  {
    "label": "聚物物流",
    "value": "juwu"
  },
  {
    "label": "聚中大",
    "value": "juzhongda"
  },
  {
    "label": "Kaha Epress",
    "value": "kahaexpress"
  },
  {
    "label": "Kangaroo Express",
    "value": "kangaroo"
  },
  {
    "label": "肯尼亚(POSTA KENYA)",
    "value": "kenya"
  },
  {
    "label": "Kerry Express",
    "value": "kerryexpress"
  },
  {
    "label": "启邦国际物流",
    "value": "keypon"
  },
  {
    "label": "快服务",
    "value": "kfwnet"
  },
  {
    "label": "跨境直邮通",
    "value": "kjde"
  },
  {
    "label": "Kuehne + Nagel",
    "value": "kn"
  },
  {
    "label": "考拉速递",
    "value": "koalaexp"
  },
  {
    "label": "番薯国际货运",
    "value": "koali"
  },
  {
    "label": "快捷物流",
    "value": "kuaijiewuliu"
  },
  {
    "label": "快淘快递",
    "value": "kuaitao"
  },
  {
    "label": "四川快优达速递",
    "value": "kuaiyouda"
  },
  {
    "label": "Kuehne+Nagel",
    "value": "kuehnenagel"
  },
  {
    "label": "KURASI",
    "value": "kurasi"
  },
  {
    "label": "凯信达",
    "value": "kxda"
  },
  {
    "label": "吉尔吉斯斯坦(Kyrgyz Post)",
    "value": "kyrgyzpost"
  },
  {
    "label": "跨跃国际",
    "value": "kyue"
  },
  {
    "label": "蓝镖快递",
    "value": "lanbiaokuaidi"
  },
  {
    "label": "Landmark Global",
    "value": "landmarkglobal"
  },
  {
    "label": "蓝弧快递",
    "value": "lanhukuaidi"
  },
  {
    "label": "老挝(Lao Express) ",
    "value": "lao"
  },
  {
    "label": "塞内加尔",
    "value": "laposte"
  },
  {
    "label": "拉脱维亚(Latvijas Pasts)",
    "value": "latviaen"
  },
  {
    "label": "立白宝凯物流",
    "value": "lbbk"
  },
  {
    "label": "两点之间",
    "value": "ldzy168"
  },
  {
    "label": "乐达全球速递",
    "value": "ledaexpress"
  },
  {
    "label": "楽道物流",
    "value": "ledaowuliu"
  },
  {
    "label": "乐递供应链",
    "value": "ledii"
  },
  {
    "label": "云豹国际货运",
    "value": "leopard"
  },
  {
    "label": "莱索托(Lesotho Post)",
    "value": "lesotho"
  },
  {
    "label": "美联快递",
    "value": "letseml"
  },
  {
    "label": "Laxship",
    "value": "lexship"
  },
  {
    "label": "lazada",
    "value": "lgs"
  },
  {
    "label": "联运快递",
    "value": "lianyun"
  },
  {
    "label": "黎巴嫩(Liban Post)",
    "value": "libanpost"
  },
  {
    "label": "Lion Parcel",
    "value": "lionparcel"
  },
  {
    "label": "丽狮物流",
    "value": "lishi"
  },
  {
    "label": "立陶宛（Lietuvos pa?tas）",
    "value": "lithuania"
  },
  {
    "label": "良藤国际速递",
    "value": "lmfex"
  },
  {
    "label": "新易泰",
    "value": "lnet"
  },
  {
    "label": "Loadbugs",
    "value": "loadbugs"
  },
  {
    "label": "隆浪快递",
    "value": "longlangkuaidi"
  },
  {
    "label": "长风物流",
    "value": "longvast"
  },
  {
    "label": "Loomis Express",
    "value": "loomisexpress"
  },
  {
    "label": "联通快递",
    "value": "ltparcel"
  },
  {
    "label": "吉捷国际速递",
    "value": "luckyfastex"
  },
  {
    "label": "论道国际物流",
    "value": "lundao"
  },
  {
    "label": "卢森堡(Luxembourg Post)",
    "value": "luxembourg"
  },
  {
    "label": "卢森堡(Luxembourg Post)",
    "value": "luxembourgde"
  },
  {
    "label": "卢森堡(Luxembourg Post)",
    "value": "luxembourgfr"
  },
  {
    "label": "路遥物流",
    "value": "luyao"
  },
  {
    "label": "马其顿(Macedonian Post)",
    "value": "macedonia"
  },
  {
    "label": "Maersk",
    "value": "maersk"
  },
  {
    "label": "mailamericas",
    "value": "mailamericas"
  },
  {
    "label": "麦力快递",
    "value": "mailikuaidi"
  },
  {
    "label": "迈隆递运",
    "value": "mailongdy"
  },
  {
    "label": "Mainfreight",
    "value": "mainfreight"
  },
  {
    "label": "马尔代夫(Maldives Post)",
    "value": "maldives"
  },
  {
    "label": "马耳他（Malta Post）",
    "value": "malta"
  },
  {
    "label": "芒果速递",
    "value": "mangguo"
  },
  {
    "label": "今枫国际快运",
    "value": "mapleexpress"
  },
  {
    "label": "MAS Courier Servic",
    "value": "mascourierservice"
  },
  {
    "label": "Matkahuolto",
    "value": "matkahuolto"
  },
  {
    "label": "毛里求斯(Mauritius Post)",
    "value": "mauritius"
  },
  {
    "label": "澳洲迈速快递",
    "value": "maxeedexpress"
  },
  {
    "label": "Middle East Courier service",
    "value": "mecs"
  },
  {
    "label": "美邦国际快递",
    "value": "meibang"
  },
  {
    "label": "Merage ",
    "value": "merage"
  },
  {
    "label": "Mexico Senda Express",
    "value": "mexicodenda"
  },
  {
    "label": "名航速运",
    "value": "mhsy"
  },
  {
    "label": "Mitsui OSK Lines",
    "value": "mol"
  },
  {
    "label": "蒙古国(Mongol Post) ",
    "value": "mongolpost"
  },
  {
    "label": "黑山(Posta Crne Gore)",
    "value": "montenegro"
  },
  {
    "label": "摩洛哥 ( Morocco Post )",
    "value": "morocco"
  },
  {
    "label": "MRW",
    "value": "mrw"
  },
  {
    "label": "Mexico Multipack",
    "value": "multipack"
  },
  {
    "label": "中俄速通（淼信）",
    "value": "mxe56"
  },
  {
    "label": "MyHermes",
    "value": "myhermes"
  },
  {
    "label": "mylerz",
    "value": "mylerz"
  },
  {
    "label": "新亚物流",
    "value": "nalexpress"
  },
  {
    "label": "纳米比亚(NamPost)",
    "value": "namibia"
  },
  {
    "label": "NandanCourier",
    "value": "nandan"
  },
  {
    "label": "Nationex",
    "value": "nationex"
  },
  {
    "label": "红马速递",
    "value": "nedahm"
  },
  {
    "label": "荷兰速递(Nederland Post)",
    "value": "nederlandpost"
  },
  {
    "label": "尼尔快递",
    "value": "nell"
  },
  {
    "label": "尼泊尔（Nepal Postal Services）",
    "value": "nepalpost"
  },
  {
    "label": "Network Courier",
    "value": "networkcourier"
  },
  {
    "label": "哪吒速运",
    "value": "nezhasuyun"
  },
  {
    "label": "Ninja Van ",
    "value": "ninjavan"
  },
  {
    "label": "ninja xpress",
    "value": "ninjaxpress"
  },
  {
    "label": "Nippon Express",
    "value": "nipponexpress"
  },
  {
    "label": "牛仔速运",
    "value": "niuzaiexpress"
  },
  {
    "label": "NLE",
    "value": "nle"
  },
  {
    "label": "亚欧专线",
    "value": "nlebv"
  },
  {
    "label": "Norsk Global",
    "value": "norsk_global"
  },
  {
    "label": "Nova Poshta",
    "value": "novaposhta"
  },
  {
    "label": "诺尔国际物流",
    "value": "nuoer"
  },
  {
    "label": "NYK Line",
    "value": "nyk"
  },
  {
    "label": "OCA Argentina",
    "value": "ocaargen"
  },
  {
    "label": "﻿OCS ANA Group",
    "value": "ocsindia"
  },
  {
    "label": "阿曼(Oman Post)",
    "value": "oman"
  },
  {
    "label": "无限配",
    "value": "omni2"
  },
  {
    "label": "Omni Parcel",
    "value": "omniparcel"
  },
  {
    "label": "爱沙尼亚(Eesti Post)",
    "value": "omniva"
  },
  {
    "label": "One World Express",
    "value": "oneworldexpress"
  },
  {
    "label": "昂威物流",
    "value": "onway"
  },
  {
    "label": "OPEK",
    "value": "opek"
  },
  {
    "label": "OPEX",
    "value": "opex"
  },
  {
    "label": "Packlink",
    "value": "packlink"
  },
  {
    "label": "巴拿马",
    "value": "panama"
  },
  {
    "label": "Pandu Logistics",
    "value": "pandulogistics"
  },
  {
    "label": "巴拉圭(Correo Paraguayo)",
    "value": "paraguay"
  },
  {
    "label": "parcel2go",
    "value": "parcel2go"
  },
  {
    "label": "Park N Pracel",
    "value": "parknparcel"
  },
  {
    "label": "paxel",
    "value": "paxel"
  },
  {
    "label": "paxelen",
    "value": "paxelen"
  },
  {
    "label": "普畅物流",
    "value": "pcwl56"
  },
  {
    "label": "全球速递",
    "value": "pdstow"
  },
  {
    "label": "派尔快递",
    "value": "peex"
  },
  {
    "label": "配思货运",
    "value": "peisihuoyunkuaidi"
  },
  {
    "label": "鹏程快递",
    "value": "pengcheng"
  },
  {
    "label": "鹏远国际速递",
    "value": "pengyuanexpress"
  },
  {
    "label": "秘鲁(SERPOST)",
    "value": "peru"
  },
  {
    "label": "Presto",
    "value": "pesto"
  },
  {
    "label": "Parcel Freight Logistics",
    "value": "pflogistics"
  },
  {
    "label": "pickupp",
    "value": "pickupp"
  },
  {
    "label": "品速心达快递",
    "value": "pinsuxinda"
  },
  {
    "label": "品信快递",
    "value": "pinxinkuaidi"
  },
  {
    "label": "龙行天下",
    "value": "pmt0704be"
  },
  {
    "label": "葡萄牙（Portugal CTT）",
    "value": "portugalctten"
  },
  {
    "label": "POS INDONESIA",
    "value": "posindonesia"
  },
  {
    "label": "坦桑尼亚（Tanzania Posts Corporation）",
    "value": "posta"
  },
  {
    "label": "PostElbe",
    "value": "postelbe"
  },
  {
    "label": "挪威（Posten Norge）",
    "value": "postennorge"
  },
  {
    "label": "PostNord Logistics",
    "value": "postnord"
  },
  {
    "label": "巴布亚新几内亚(PNG Post)",
    "value": "postpng"
  },
  {
    "label": "PT Prima Multi Cipta",
    "value": "primamulticipta"
  },
  {
    "label": "土耳其",
    "value": "ptt"
  },
  {
    "label": "ANTS EXPRESS",
    "value": "qdants"
  },
  {
    "label": "7E速递",
    "value": "qesd"
  },
  {
    "label": "雪域快递",
    "value": "qhxykd"
  },
  {
    "label": "启辰国际速递",
    "value": "qichen"
  },
  {
    "label": "卡塔尔（Qatar Post）",
    "value": "qpost"
  },
  {
    "label": "千顺快递",
    "value": "qskdyxgs"
  },
  {
    "label": "全信通快递",
    "value": "quanxintong"
  },
  {
    "label": "Qxpress",
    "value": "qxpress"
  },
  {
    "label": "全之鑫物流",
    "value": "qzx56"
  },
  {
    "label": "R2S Logistics",
    "value": "r2slogistics"
  },
  {
    "label": "RAM",
    "value": "ramgroup_za"
  },
  {
    "label": "Rapido Cargo Egypt",
    "value": "rapidocargoeg"
  },
  {
    "label": "Red Express",
    "value": "redexpress"
  },
  {
    "label": "Redur",
    "value": "redur"
  },
  {
    "label": "Redur Spain",
    "value": "redur_es"
  },
  {
    "label": "日昱物流",
    "value": "riyuwuliu"
  },
  {
    "label": "RL Carriers",
    "value": "rl_carriers"
  },
  {
    "label": "罗马尼亚（Posta Romanian）",
    "value": "romanian"
  },
  {
    "label": "皇家国际速运",
    "value": "royal"
  },
  {
    "label": "日日通国际",
    "value": "rrthk"
  },
  {
    "label": "瑞典（Sweden Post）",
    "value": "ruidianyouzhengen"
  },
  {
    "label": "润百特货",
    "value": "runbail"
  },
  {
    "label": "卢旺达(Rwanda i-posita)",
    "value": "rwanda"
  },
  {
    "label": "S2C",
    "value": "s2c"
  },
  {
    "label": "Safexpress",
    "value": "safexpress"
  },
  {
    "label": "佐川急便-英文",
    "value": "sagawaen"
  },
  {
    "label": "Correo El Salvador",
    "value": "salvador"
  },
  {
    "label": "SAP EXPRESS",
    "value": "sapexpress"
  },
  {
    "label": "沙特阿拉伯(Saudi Post)",
    "value": "saudipost"
  },
  {
    "label": "SCCS",
    "value": "sccs"
  },
  {
    "label": "SCG",
    "value": "scglogistics"
  },
  {
    "label": "四川星程快递",
    "value": "scxingcheng"
  },
  {
    "label": "速呈",
    "value": "sczpds"
  },
  {
    "label": "首达速运",
    "value": "sdsy888"
  },
  {
    "label": "Selektvracht",
    "value": "selektvracht"
  },
  {
    "label": "森鼎国际物流",
    "value": "sendinglog"
  },
  {
    "label": "Sendle",
    "value": "sendle"
  },
  {
    "label": "塞尔维亚(PE Post of Serbia)",
    "value": "serbia"
  },
  {
    "label": "International Seur",
    "value": "seur"
  },
  {
    "label": "澳丰速递",
    "value": "sfau"
  },
  {
    "label": "SFC",
    "value": "sfc"
  },
  {
    "label": "SFC Service",
    "value": "sfcservice"
  },
  {
    "label": "圣飞捷快递",
    "value": "sfjhd"
  },
  {
    "label": "曹操到",
    "value": "sfpost"
  },
  {
    "label": "Shadowfax",
    "value": "shadowfax"
  },
  {
    "label": "衫达快运",
    "value": "shanda56"
  },
  {
    "label": "尚橙物流",
    "value": "shangcheng"
  },
  {
    "label": "上海无疆for买卖宝",
    "value": "shanghaiwujiangmmb"
  },
  {
    "label": "尚途国际货运",
    "value": "shangtuguoji"
  },
  {
    "label": "捎客物流",
    "value": "shaoke"
  },
  {
    "label": "商海德物流",
    "value": "shd56"
  },
  {
    "label": "神骏物流",
    "value": "shenjun"
  },
  {
    "label": "神马快递",
    "value": "shenma"
  },
  {
    "label": "阳光快递",
    "value": "shiningexpress"
  },
  {
    "label": "ShipBlu",
    "value": "shipblu"
  },
  {
    "label": "王牌快递",
    "value": "shipbyace"
  },
  {
    "label": "苏豪快递",
    "value": "shipsoho"
  },
  {
    "label": "世运快递",
    "value": "shiyunkuaidi"
  },
  {
    "label": "SHL畅灵国际物流",
    "value": "shlexp"
  },
  {
    "label": "wish邮",
    "value": "shpostwish"
  },
  {
    "label": "shreeanjanicourier",
    "value": "shreeanjanicourier"
  },
  {
    "label": "顺邦国际物流",
    "value": "shunbang"
  },
  {
    "label": "SiCepat Ekspres",
    "value": "sicepat"
  },
  {
    "label": "四海快递",
    "value": "sihaiet"
  },
  {
    "label": "四海捷运",
    "value": "sihiexpress"
  },
  {
    "label": "易普递",
    "value": "sixroad"
  },
  {
    "label": "Sky Express",
    "value": "skyexpresseg"
  },
  {
    "label": "skynet",
    "value": "skynet"
  },
  {
    "label": "SkyNet Malaysia",
    "value": "skynetmalaysia"
  },
  {
    "label": "荷兰Sky Post",
    "value": "skypost"
  },
  {
    "label": "Asendia HK (LATAM)",
    "value": "skypostal"
  },
  {
    "label": "斯洛伐克(Slovenská Posta)",
    "value": "slovak"
  },
  {
    "label": "斯洛文尼亚(Slovenia Post)",
    "value": "slovenia"
  },
  {
    "label": "斯里兰卡(Sri Lanka Post)",
    "value": "slpost"
  },
  {
    "label": "SMSA Express",
    "value": "smsaexpress"
  },
  {
    "label": "所罗门群岛",
    "value": "solomon"
  },
  {
    "label": "布基纳法索",
    "value": "sonapost"
  },
  {
    "label": "Speedaf",
    "value": "speedaf"
  },
  {
    "label": " Speed Shipping Company",
    "value": "speedegypt"
  },
  {
    "label": "SpeedEx",
    "value": "speedex"
  },
  {
    "label": "申必达",
    "value": "speedoex"
  },
  {
    "label": "Spoton",
    "value": "spoton"
  },
  {
    "label": "Sprint",
    "value": "sprint"
  },
  {
    "label": "速速达",
    "value": "ssd"
  },
  {
    "label": "星速递",
    "value": "starex"
  },
  {
    "label": "星运快递",
    "value": "staryvr"
  },
  {
    "label": "圣卢西亚",
    "value": "stlucia"
  },
  {
    "label": "智德物流",
    "value": "stzd56"
  },
  {
    "label": "特急便物流",
    "value": "sucmj"
  },
  {
    "label": "苏丹（Sudapost）",
    "value": "sudapost"
  },
  {
    "label": "郑州速捷",
    "value": "sujievip"
  },
  {
    "label": "速品快递",
    "value": "supinexpress"
  },
  {
    "label": "苏里南",
    "value": "surpost"
  },
  {
    "label": "圣文森特和格林纳丁斯",
    "value": "svgpost"
  },
  {
    "label": "斯威士兰",
    "value": "swaziland"
  },
  {
    "label": "Amazon FBA Swiship",
    "value": "swiship"
  },
  {
    "label": "红马甲物流",
    "value": "sxhongmajia"
  },
  {
    "label": "顺友物流",
    "value": "sypost"
  },
  {
    "label": "深圳DPEX",
    "value": "szdpex"
  },
  {
    "label": "天美快递",
    "value": "taimek"
  },
  {
    "label": "Talabat ",
    "value": "talabat"
  },
  {
    "label": "坦桑尼亚(Tanzania Posts)",
    "value": "tanzania"
  },
  {
    "label": "淘布斯国际物流",
    "value": "taoplus"
  },
  {
    "label": "淘特物流快递",
    "value": "taote"
  },
  {
    "label": "TCI XPS",
    "value": "tcixps"
  },
  {
    "label": "GPI",
    "value": "tcxbthai"
  },
  {
    "label": "TD Cargo",
    "value": "tdcargo"
  },
  {
    "label": "The BlueBhell Couriers",
    "value": "thebluebhellcouriers"
  },
  {
    "label": "The Courier Guy",
    "value": "thecourierguy"
  },
  {
    "label": "TiKi",
    "value": "tiki"
  },
  {
    "label": "TIPSA",
    "value": "tipsa"
  },
  {
    "label": "Shree Tirupati",
    "value": "tirupati"
  },
  {
    "label": "老扬州物流",
    "value": "tjlyz56"
  },
  {
    "label": "天联快运",
    "value": "tlky"
  },
  {
    "label": "株式会社T.M.G",
    "value": "tmg"
  },
  {
    "label": "TNY物流",
    "value": "tny"
  },
  {
    "label": "多哥",
    "value": "togo"
  },
  {
    "label": "通达兴物流",
    "value": "tongdaxing"
  },
  {
    "label": "顶世国际物流",
    "value": "topshey"
  },
  {
    "label": "The Professional Couriers",
    "value": "tpcindia"
  },
  {
    "label": "track-parcel",
    "value": "trackparcel"
  },
  {
    "label": "Trans Kargo",
    "value": "transkargologistics"
  },
  {
    "label": "Transporter Egypt",
    "value": "transporter"
  },
  {
    "label": "Turbo",
    "value": "turbo"
  },
  {
    "label": "UBX",
    "value": "ubx"
  },
  {
    "label": "UEX国际物流",
    "value": "uex"
  },
  {
    "label": "欧洲UEX",
    "value": "uexiex"
  },
  {
    "label": "Ufelix",
    "value": "ufelix"
  },
  {
    "label": "乌干达(Posta Uganda)",
    "value": "uganda"
  },
  {
    "label": "邮鸽速运",
    "value": "ugoexpress"
  },
  {
    "label": "乌克兰小包、大包(UkrPoshta)",
    "value": "ukraine"
  },
  {
    "label": "乌克兰小包、大包(UkrPost)",
    "value": "ukrpost"
  },
  {
    "label": "优联吉运",
    "value": "uluckex"
  },
  {
    "label": "Uni Express",
    "value": "uniexpress"
  },
  {
    "label": "Union Courier SAE",
    "value": "unioncourier"
  },
  {
    "label": "United express courier service",
    "value": "unitedexpress"
  },
  {
    "label": "UParcel",
    "value": "uparcel"
  },
  {
    "label": "UPS Freight",
    "value": "upsfreight"
  },
  {
    "label": "UPS Mail Innovations",
    "value": "upsmailinno"
  },
  {
    "label": "UTAO优到",
    "value": "utaoscm"
  },
  {
    "label": "瓦努阿图(Vanuatu Post)",
    "value": "vanuatu"
  },
  {
    "label": "越中国际物流",
    "value": "vctrans"
  },
  {
    "label": "越南小包(Vietnam Posts)",
    "value": "vietnam"
  },
  {
    "label": "鹰运国际速递",
    "value": "vipexpress"
  },
  {
    "label": "维普恩物流",
    "value": "vps"
  },
  {
    "label": "Wadily",
    "value": "wadily"
  },
  {
    "label": "Wahana",
    "value": "wahana"
  },
  {
    "label": "万博快递",
    "value": "wanboex"
  },
  {
    "label": "豌豆物流",
    "value": "wandougongzhu"
  },
  {
    "label": "宁夏万家通",
    "value": "wanjiatong"
  },
  {
    "label": "WassalNow",
    "value": "wassalnow"
  },
  {
    "label": "万达美",
    "value": "wdm"
  },
  {
    "label": "Wedel",
    "value": "wedel"
  },
  {
    "label": "世航通运",
    "value": "welogistics"
  },
  {
    "label": "文捷航空",
    "value": "wenjiesudi"
  },
  {
    "label": "威速递",
    "value": "wexpress"
  },
  {
    "label": "香港伟豪国际物流",
    "value": "whgjkd"
  },
  {
    "label": "Whistl",
    "value": "whistl"
  },
  {
    "label": "万邑通",
    "value": "winit"
  },
  {
    "label": "凡仕特物流",
    "value": "wlfast"
  },
  {
    "label": "万理诺物流",
    "value": "wln"
  },
  {
    "label": "星空国际",
    "value": "wlwex"
  },
  {
    "label": "渥途国际速运",
    "value": "wotu"
  },
  {
    "label": "wowexpress",
    "value": "wowexpress"
  },
  {
    "label": "沃埃家",
    "value": "wowvip"
  },
  {
    "label": "WTD海外通",
    "value": "wtdex"
  },
  {
    "label": "臣邦同城",
    "value": "wto56kj"
  },
  {
    "label": "万运国际快递",
    "value": "wygj168"
  },
  {
    "label": "微转运",
    "value": "wzhaunyun"
  },
  {
    "label": "国晶物流",
    "value": "xdshipping"
  },
  {
    "label": "鑫宏福物流",
    "value": "xhf56"
  },
  {
    "label": "西安城联速递",
    "value": "xianchengliansudi"
  },
  {
    "label": "西安喜来快递",
    "value": "xilaikd"
  },
  {
    "label": "新元快递",
    "value": "xingyuankuaidi"
  },
  {
    "label": "Xpert Delivery",
    "value": "xpertdelivery"
  },
  {
    "label": "XpressBees",
    "value": "xpressbees"
  },
  {
    "label": "鑫世锐达",
    "value": "xsrd"
  },
  {
    "label": "鑫通宝物流",
    "value": "xtb"
  },
  {
    "label": "鑫远东速运",
    "value": "xyd666"
  },
  {
    "label": "一辉物流",
    "value": "yatfai"
  },
  {
    "label": "YCG物流",
    "value": "ycgglobal"
  },
  {
    "label": "一邦速递",
    "value": "yibangwuliu"
  },
  {
    "label": "易达通",
    "value": "yidatong"
  },
  {
    "label": "驿递汇速递",
    "value": "yidihui"
  },
  {
    "label": "艺凡快递",
    "value": "yifankd"
  },
  {
    "label": "易航物流",
    "value": "yihangmall"
  },
  {
    "label": "yikonn",
    "value": "yikonn"
  },
  {
    "label": "亿领速运",
    "value": "yilingsuyun"
  },
  {
    "label": "易欧洲国际物流",
    "value": "yiouzhou"
  },
  {
    "label": "一柒国际物流",
    "value": "yiqiguojiwuliu"
  },
  {
    "label": "宜送",
    "value": "yisong"
  },
  {
    "label": "易通达",
    "value": "yitongda"
  },
  {
    "label": "优胜国际速递",
    "value": "yoseus"
  },
  {
    "label": "邮驿帮高铁速运",
    "value": "youyibang"
  },
  {
    "label": "壹品速递",
    "value": "ypsd"
  },
  {
    "label": "远航国际快运",
    "value": "yuanhhk"
  },
  {
    "label": "粤中国际货运代理（上海）有限公司",
    "value": "yuezhongsh"
  },
  {
    "label": "美国云达",
    "value": "yundaexus"
  },
  {
    "label": "韵丰物流",
    "value": "yunfeng56"
  },
  {
    "label": "蕴国物流",
    "value": "yunguo56"
  },
  {
    "label": "Yusen Logistics",
    "value": "yusen"
  },
  {
    "label": "远为快递",
    "value": "ywexpress"
  },
  {
    "label": "一运全成物流",
    "value": "yyqc56"
  },
  {
    "label": "赞比亚",
    "value": "zampost"
  },
  {
    "label": "珠峰速运",
    "value": "zf365"
  },
  {
    "label": "众辉达物流",
    "value": "zhdwl"
  },
  {
    "label": "智谷特货",
    "value": "zhiguil"
  },
  {
    "label": "志腾物流",
    "value": "zhitengwuliu"
  },
  {
    "label": "众川国际",
    "value": "zhongchuan"
  },
  {
    "label": "忠信达",
    "value": "zhongxinda"
  },
  {
    "label": "众派速递",
    "value": "zhpex"
  },
  {
    "label": "增速跨境 ",
    "value": "zyzoom"
  }
]

export default express